import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription, forkJoin } from 'rxjs';
import { HttpcallService } from 'src/app/common/services/httpcall.service';
import { CommonDataService } from '../../common/services/common-data.service';
import { GraphqlService } from '../../common/services/graphql.service';
import { LoginService } from '../../common/services/Login.service';
import { SessionService } from '../../common/services/Session.service';
import { filter } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit, OnDestroy {

  constructor(
    private route: Router,
    private commonDataService: CommonDataService,
    public loginService: LoginService,
    private graphQlService: GraphqlService,
    private httpCall: HttpcallService,
    private session: SessionService,
    private domsanitizer: DomSanitizer,
    private searchroute: ActivatedRoute
  ) { }
  elasticSearchCondition = {
    Searchterm: "",
    // SourceType: "",
    Chapter: [],
    DocumentType: [],
    ContentType: [],
    Section: [],
    PageNumber: 0,
    PronouncementType: [],
    AuthoritativeType: [],
    CIGContentType: []
  };
  contentTypeResult: any = [];
  documentTypeResult: any = [];
  authoritativeTypeResult: any = [];
  chapterResult: any = [];
  cigContentTypeResult: any = [];
  cigGlossaryChapterResult: any = [];
  selectedChapter: any = [];
  areaResult: any = [];
  otherAreaResult: any = [];
  SelectedOtherAreaResult: any = [];
  selectedOtherContentType: any = [];
  sectionsResult: any = [];
  codGlossarySectionsResult: any = [];
  sections = new FormControl();
  SelectedSection: any = [];
  selectedContentType: any = [];
  selectedDocumentType: any = [];
  selectedAuthType: any = [];
  SelectedPronouncement: any = [];
  pronouncementNumber = new FormControl();
  pronouncementNumbersResult: any = [];
  opGlossaryPrononucementResult: any = [];
  contentTypeList: string[] = [];
  chapterTypeList: string[] = [];
  documentTypeList: string[] = [];
  selectedCigFilters: string[] = [];
  selectedFilterControl = new FormControl();
  selectedType: string = '';
  searchbyfilter: boolean = false;
  showingResults;
  paragraphHeader;
  topicsHeader;
  othersHeader;
  searchHeading;
  samplePara1;
  samplePara2;
  samplePara3;
  narrowResults;
  contentType;
  originalPronouncements;
  narrowResult1;
  narrowResult2;
  narrowResult3;
  narrowResult4;
  contentType1;
  contentType2;
  inputIntegerated;
  codification;
  implementationGuide;
  opParagraph;
  glossary;
  MyAnnotations;
  MyBookmarks;
  illustrations;
  statement;
  interpretation;
  technical;
  standard;
  searchAicpa;
  bulletin;
  filter;
  gasbImplementation;
  relatedSearch; relatedTopic;
  section;
  implementationGuidance;
  addbutton;
  outcomeStatus: boolean = false;
  userId: string = "";
  role: string = "";
  mailId: string = "";
  recentSearchTerm;
  searchtext;

  
  activeTab: string = "";
  glossaryTermUsage: string = "";
  noLinks: string = "";
  see: string = "";
  annotationResult;
  tempannotationResult;
  bookmarkResult;
  tempBookmarkResult;
  codGlossaryResult;
  tempcodGlossaryResult;
  CodGlossaryResultCount: number = 0;
  opGlossaryResult;
  tempopGlossaryResult;
  OpGlossaryResultCount: number = 0;
  cigGlossaryResult;
  tempcigGlossaryResult;
  CigGlossaryResultCount: number = 0;
  annotationCount: number = 0;
  bookmarkCount: number = 0;
  otherCount: number = 0;
  topic: any;
  contacts: any = [];
  body: any;
  title: any;
  GlossaryColumnlabels: any = [];
  leftNavmenuLevel = [1, 2, 3];
  NarrowResultsBySection: string = "";
  sectionText: string = "";
  NarrowResultsByChapter: string = "";
  NarrowResultsByDocumentType: string = "";
  NarrowResultsByAuthoritativetype: string = "";
  NarrowResultByContentType: string = "";
  totalCodSearchCount: number = 0;
  totalOpSearchCount: number = 0;
  totalCigSearchCount: number = 0;

  totalCodGlossaryCount: number = 0;
  totalOpGlossaryCount: number = 0;
  totalCigGlossaryCount: number = 0;

  CodTabResultCount: number = 0;
  OpTabResultCount: number = 0;
  CigTabResultCount: number = 0;
  ShowTabs: boolean = false;
  NoResults: string = "";
  ReviewText: string = "";
  recent: string = "";

  event$: Subscription;
  tempCodSearchResult: any = [];
  tempOpSearchResult: any = [];
  tempCigSearchResult: any = [];

  searchTabHeading: any = [];
  cigSectionFilter: any = [];
  FILTER_ARRAY = [
    { key: 'References', value: 'References' },
    { key: 'Questions and Answers', value: 'Questions and Answers' },
    { key: 'Nonauthoritative Illustrations', value: ' Nonauthoritative Illustrations' },
    { key: 'Glossary', value: 'Glossary' }
  ]
  opFiltertext: string = "";
  //isSearchPerformed = false;
  isFilterLocked = false;
  isDropdownLocked = false;
  isElasticSearchTermAvailable: boolean = true;
  ngOnInit(): void {
    this.commonDataService.showLoader.next(true);
    this.getsearchlabels();
    //this.commonDataService.searchInput.subscribe(() => {
    //  this.OperationonSearchLoad();
    //});
      if (this.session.globallablesinfo == null || this.session.globallablesinfo == undefined) {
        this.graphQlService.getGlobalLabels().subscribe(data => {
          if (data != "") {
            let labels = data.content.data.labels;
            labels = labels.filter(x => x.key.trim());
            this.glossaryTermUsage = labels.filter(x => x.key == "glossary_termUsage").map(y => y.value);
            this.noLinks = labels.filter(x => x.key == "noIncomingLink").map(y => y.value);
            // this.seeTopics = labels.filter(x => x.key == "glossary_see").map(y => y.value);
          }
        })
      }
      else {
        let labels = this.session.globallablesinfo.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.glossaryTermUsage = labels.filter(x => x.key == "glossary_termUsage").map(y => y.value);
        this.noLinks = labels.filter(x => x.key == "noIncomingLink").map(y => y.value);
      }
      this.event$
        = this.route.events
          .pipe(
            filter(event => event instanceof NavigationEnd)
          )
          .subscribe(() => {
            this.commonDataService.showLoader.next(true);
            this.getsearchlabels();
            const searchTerm = this.searchroute.snapshot.queryParamMap.get('query');
            if (searchTerm) {
              this.isFullyLoaded = false;
              this.searchNewTerm(searchTerm);
            }
          });
    const searchTerm = this.searchroute.snapshot.queryParamMap.get('query');
    if (searchTerm) {
      this.isFullyLoaded = false;
      this.searchNewTerm(searchTerm);
    }
  }


  searchNewTerm(term: string) {
    this.isElasticSearchTermAvailable = true;
    localStorage.setItem("ElasticSearchTerm", term);
    if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
      this.loginService.getSession().toPromise().then(data => {
        this.userId = data.user.userName;
        this.role = data.user.roles;
        this.mailId = data.user.email;
        if (this.role == "Professional") {
          this.httpCall.getRecentSearchTerm().subscribe(recentSearchTerm => {
            this.recentSearchTerm = recentSearchTerm;
            this.getSearchInputValues();
          })
        }
        else { this.getSearchInputValues(); }
      });
    }
    else {
      this.userId = this.session.userInfo.user.userName;
      this.role = this.session.userInfo.user.roles;
      this.mailId = this.session.userInfo.user.email;
      if (this.role == "Professional") {
        this.httpCall.getRecentSearchTerm().subscribe(recentSearchTerm => {
          this.recentSearchTerm = recentSearchTerm;
          this.getSearchInputValues();
        })
      }
      else { this.getSearchInputValues(); }
    }
  }

  //OperationonSearchLoad() {
  //  if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
  //    this.loginService.getSession().toPromise().then(data => {
  //      this.userId = data.user.userName;
  //      this.role = data.user.roles;
  //      this.mailId = data.user.email;
  //      if (localStorage.getItem("ElasticSearchTerm") != null) {
  //        this.getSearchInputValues();
  //      } else {
  //        this.isElasticSearchTermAvailable = false;
  //        if (this.role == "Professional") {
  //          this.httpCall.getRecentSearchTerm().subscribe(recentSearchTerm => {
  //            this.recentSearchTerm = recentSearchTerm; this.outcomeStatus = true;
  //            this.commonDataService.showLoader.next(false);
  //          })
  //        } else {
  //          this.outcomeStatus = true;
  //          this.commonDataService.showLoader.next(false);
  //        }
  //      }
  //    });
  //  }
  //  else {
  //    this.userId = this.session.userInfo.user.userName;
  //    this.role = this.session.userInfo.user.roles;
  //    this.mailId = this.session.userInfo.user.email;
  //    if (localStorage.getItem("ElasticSearchTerm") != null) {
  //      this.getSearchInputValues();
  //    } else {
  //      this.isElasticSearchTermAvailable = false;
  //      if (this.role == "Professional") {
  //        this.httpCall.getRecentSearchTerm().subscribe(recentSearchTerm => {
  //          this.recentSearchTerm = recentSearchTerm; this.outcomeStatus = true;
  //          this.commonDataService.showLoader.next(false);
  //        })
  //      } else {
  //        this.outcomeStatus = true;
  //        this.commonDataService.showLoader.next(false);
  //      }
  //    }
  //  }
  //}

  ngAfterContentChecked() {
    this.EnableBackToTop();
  }

  ngOnDestroy() { localStorage.removeItem("ElasticSearchTerm"); }

  getsearchlabels() {
    this.graphQlService.getSearchLabels().subscribe(data => {
      if (data != "") {
        let labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.paragraphHeader = labels.filter(x => x.key == "search_paragraphText").map(y => y.value);
        this.topicsHeader = labels.filter(x => x.key == "search_topicText").map(y => y.value);
        this.othersHeader = labels.filter(x => x.key == "search_otherText").map(y => y.value);
        this.searchtext = labels.filter(x => x.key == "search_searchGarsFor").map(y => y.value);

        this.narrowResults = labels.filter(x => x.key == "search_NarrowResult").map(y => y.value);
        this.contentType = labels.filter(x => x.key == "search_ContentType").map(y => y.value);
        this.relatedSearch = labels.filter(x => x.key == "search_SearchesRelated").map(y => y.value);
        this.showingResults = labels.filter(x => x.key == "search_ShowingResults").map(y => y.value);
        this.originalPronouncements = labels.filter(x => x.key == "search_originalPronouncements").map(y => y.value);
        this.codification = labels.filter(x => x.key == "search_codification").map(y => y.value);
        this.implementationGuide = labels.filter(x => x.key == "search_implementationGuide").map(y => y.value);
        this.opParagraph = labels.filter(x => x.key == "search_opParagraph").map(y => y.value);
        this.glossary = labels.filter(x => x.key == "search_glossary").map(y => y.value);
        this.illustrations = labels.filter(x => x.key == "search_illustration").map(y => y.value);
        this.interpretation = labels.filter(x => x.key == "search_interpretation").map(y => y.value);
        this.statement = labels.filter(x => x.key == "search_statement").map(y => y.value);
        this.technical = labels.filter(x => x.key == "search_technical").map(y => y.value);
        this.gasbImplementation = labels.filter(x => x.key == "search_gasbImplementation").map(y => y.value);
        this.standard = labels.filter(x => x.key == "search_standard").map(y => y.value);
        this.bulletin = labels.filter(x => x.key == "search_bulletin").map(y => y.value);
        this.implementationGuidance = labels.filter(x => x.key == "search_implementationGuidance").map(y => y.value);
        this.searchAicpa = labels.filter(x => x.key == "search_aicpa").map(y => y.value);
        this.section = labels.filter(x => x.key == "search_section").map(y => y.value);
        this.filter = labels.filter(x => x.key == "search_filter").map(y => y.value);
        this.contentType1 = labels.filter(x => x.key == "search_Fasb").map(y => y.value);
        this.contentType2 = labels.filter(x => x.key == "search_Sec").map(y => y.value);
        this.MyAnnotations = labels.filter(x => x.key == "search_MyAnnotations").map(y => y.value);
        this.MyBookmarks = labels.filter(x => x.key == "search_MyBookmarks").map(y => y.value);
        this.NarrowResultsBySection = labels.filter(x => x.key == "search_NarrowResultBySection").map(y => y.value);
        this.NarrowResultByContentType = labels.filter(x => x.key == "search_NarrowResultByContentType").map(y => y.value);
        this.sectionText = labels.filter(x => x.key == "search_filter").map(y => y.value);
        this.see = labels.filter(x => x.key == "search_see").map(y => y.value);
        this.NarrowResultsByChapter = labels.filter(x => x.key == "search_NarrowResultByChapter").map(y => y.value);
        this.NarrowResultsByDocumentType = labels.filter(x => x.key == "search_NarrowResultByDocumentType").map(y => y.value);
        this.NarrowResultsByAuthoritativetype = labels.filter(x => x.key == "search_NarrowResultByAuthoritativeType").map(y => y.value);
        this.NoResults = labels.filter(x => x.key == "search_NoResults").map(y => y.value);
        this.ReviewText = labels.filter(x => x.key == "search_ReviewText").map(y => y.value);
        this.recent = labels.filter(x => x.key == "search_recent").map(y => y.value);
        this.contentTypeList = labels.filter(x => x.key == "search_contentTypeList").map(y => y.value)[0].split(",");
        this.chapterTypeList = labels.filter(x => x.key == "search_chapterTypeList").map(y => y.value)[0].split(",");
        this.documentTypeList = labels.filter(x => x.key == "search_documentTypeList").map(y => y.value)[0].split(",");
        this.opFiltertext = labels.filter(x => x.key == "search_op_filter_text").map(y => y.value);
        this.graphQlService.getCurrentVersionLeftNavigation().subscribe(leftnav => {
          //this.graphQlService.getLeftNavigation().subscribe(leftnav => {
          this.GlossaryColumnlabels = leftnav.filter((el, i) => this.leftNavmenuLevel.some(j => i === j)).map(y => y.item);
          this.GlossaryColumnlabels.forEach(columnLabels => {
            if (columnLabels.toLocaleLowerCase().includes(("Codification").toLocaleLowerCase()) || columnLabels.toLocaleLowerCase().includes(("Original Pronouncements").toLocaleLowerCase()) || columnLabels.toLocaleLowerCase().includes(("Comprehensive Implementation Guide").toLocaleLowerCase())) {
              let searchTabs = {
                key: "",
                docCount: 0
              }
              searchTabs.key = columnLabels;
              if (!this.searchTabHeading.some(x => x.key.toLocaleLowerCase().includes((columnLabels).toLocaleLowerCase()))) {
                this.searchTabHeading.push(searchTabs);
              }
            }
          })
          if (this.searchTabHeading.length != 3) {
            if (!this.searchTabHeading.some(x => x.key.toLocaleLowerCase().includes(("Codification").toLocaleLowerCase()))) {
              let searchTabs = {
                key: "",
                docCount: 0
              }
              searchTabs.key = "Codification";
              this.searchTabHeading.push(searchTabs);
            }
            if (!this.searchTabHeading.some(x => x.key.toLocaleLowerCase().includes(("Original Pronouncements").toLocaleLowerCase()))) {
              let searchTabs = {
                key: "",
                docCount: 0
              }
              searchTabs.key = "Original Pronouncements";
              this.searchTabHeading.push(searchTabs);
            }
            if (!this.searchTabHeading.some(x => x.key.toLocaleLowerCase().includes(("Comprehensive Implementation Guide").toLocaleLowerCase()))) {
              let searchTabs = {
                key: "",
                docCount: 0
              }
              searchTabs.key = "Comprehensive Implementation Guide";
              this.searchTabHeading.push(searchTabs);
            }
          }
          this.setTabCount();
        })
      }

    });
    if (this.session.globallablesinfo == null || this.session.globallablesinfo == undefined) {
      this.graphQlService.getGlobalLabels().subscribe(data => {
        if (data != "") {
          let labels = data.content.data.labels;
          labels = labels.filter(x => x.key.trim());
          this.addbutton = labels.filter(x => x.key == "global_add").map(y => y.value);
          this.session.assignglobalinfo(data);
        }
      });
    }
    else {
      let labels = this.session.globallablesinfo.content.data.labels;
      labels = labels.filter(x => x.key.trim());
      this.addbutton = labels.filter(x => x.key == "global_add").map(y => y.value);
    }
  }
  category: number = 0;
  CodSearchResult: any = [];
  CodSearchResultCount: number = 0;
  OpSearchResult: any = [];
  OpSearchResultCount: number = 0;
  CigSearchResult: any = [];
  CigSearchResultCount: number = 0;
  OpResultCount: number = 0;
  CigResultCount: number = 0;
  numberOfResult: number = 0;
  codPageCount: number = 0;
  opPageCount: number = 0;
  cigPageCount: number = 0;
  CodResultCount: number = 0;
  codFilterExists: boolean = false;
  opFilterExists: boolean = false;
  cigFilterExists: boolean = false;

  opGlossaryChecked: boolean = false;
  codGlossaryChecked: boolean = false;
  cigGlossaryChecked: boolean = false;

  AnnotationChecked: boolean = false;
  BookmarkChecked: boolean = false;
  isFullyLoaded: boolean;
  codLoaded: boolean;
  annotation_bookmark_loaded: boolean;
  op_cig_loaded: boolean;
  tempSectionsResult: any = [];
  tempContentTypesResult: any = [];
  tempPronouncementNumbersResult: any = [];

  getSearchInputValues() {
    this.outcomeStatus = false;
    this.commonDataService.showLoader.next(true);
    this.category = 0;
    this.codPageCount = 0;
    this.opPageCount = 0;
    this.cigPageCount = 0;
    this.codGlossaryChecked = false;
    this.opGlossaryChecked = false;
    this.cigGlossaryChecked = false;
    this.AnnotationChecked = false;
    this.BookmarkChecked = false;
    this.SelectedSection = [];
    this.selectedChapter = [];
    this.selectedContentType = [];
    this.selectedCigFilters = [];
    this.selectedDocumentType = [];
    this.selectedOtherContentType = [];
    this.SelectedOtherAreaResult = [];
    this.SelectedPronouncement = [];
    this.elasticSearchCondition = {
      Searchterm: "",
      Chapter: [],
      DocumentType: [],
      ContentType: [],
      Section: [],
      PageNumber: 0,
      PronouncementType: [],
      AuthoritativeType: [],
      CIGContentType: []
    };

    this.isFullyLoaded = false;
    this.codLoaded = false;
    this.annotation_bookmark_loaded = false;
    this.op_cig_loaded = false;

    this.CodSearchResult = [];
    this.codGlossaryResult = [];
    this.OpSearchResult = [];
    this.opGlossaryResult = [];
    this.CigSearchResult = [];
    this.cigGlossaryResult = [];
    this.sectionsResult = [];
    this.tempContentTypesResult = [];
    this.tempSectionsResult = [];
    this.tempPronouncementNumbersResult = [];
    this.GlossaryPronouncementFilter = [];
    this.codGlossarySectionsResult = [];
    this.opGlossaryPrononucementResult = [];
    this.cigGlossaryChapterResult = [];

    this.elasticSearchCondition.Searchterm = localStorage.getItem("ElasticSearchTerm");
    this.elasticSearchCondition.Searchterm = this.elasticSearchCondition.Searchterm.replace(/[^a-zA-Z0-9 \.\/\'\"*\-()]/g, " ").trim();

    if (this.elasticSearchCondition.Searchterm.replace(/\*/gi, "").trim() != "") {
      forkJoin(this.graphQlService.getCodElasticSearch(this.elasticSearchCondition, this.codPageCount), this.graphQlService.GetMasterGlossarySearch(this.elasticSearchCondition.Searchterm, this.codPageCount, "COD"))
        .subscribe(([codSearchResult, codglossary]) => {
          if (codSearchResult) {
            this.sectionsResult = codSearchResult?.aggregations?.section?.buckets;
            this.CodSearchResult = codSearchResult.hits?.hitsList; this.CodSearchResultCount = codSearchResult.hits?.hitsList?.length; this.totalCodSearchCount = codSearchResult.hits?.total?.value; this.tempCodSearchResult = this.CodSearchResult;
            this.CodGlossaryResultCount = codglossary?.hits?.hitsList?.length; this.codGlossaryResult = this.mapGlossaryContent(codglossary?.hits?.hitsList, "codification"); this.tempcodGlossaryResult = this.codGlossaryResult;
            this.totalCodGlossaryCount = codglossary?.hits?.total?.value; this.CodTabResultCount = this.totalCodSearchCount + this.totalCodGlossaryCount;

            this.sectionsResult.sort((first, second) => this.sortAlphaNum(first.key, second.key) ? -1 : 1);
            this.contentTypeResult = codSearchResult?.aggregations?.contentTypes?.buckets;
            if (this.contentTypeResult.filter(x => x.key == "Definitions").length > 0) {
              var defcount = this.contentTypeResult.filter(x => x.key == "Definitions").map(y => y.docCount)[0];
              var totaldefcount = defcount + this.totalCodGlossaryCount
              this.contentTypeResult.filter(u => u.docCount = (u.key == "Definitions" ? totaldefcount : u.docCount))
              this.codGlossaryChecked = true;
            }
            else if (this.totalCodGlossaryCount > 0) {
              this.contentTypeResult.push({ key: "Definitions", docCount: 0 })
              this.contentTypeResult.map(u => u.docCount = (u.key == "Definitions" ? this.totalCodGlossaryCount : u.docCount));
              this.codGlossaryChecked = true;
            }
            this.contentTypeResult = this.contentTypeResult.sort((a, b) => {
              return this.sortContentType(a, b);
            });

            this.CodResultCount = this.CodSearchResultCount + this.CodGlossaryResultCount;
            this.CodTabResultCount = this.totalCodSearchCount + this.totalCodGlossaryCount;
            this.numberOfResult = this.CodTabResultCount + this.OpTabResultCount + this.CigTabResultCount + this.otherCount;

            this.codGlossarySectionsResult = codglossary?.aggregations?.sourceTypes?.buckets;
            this.setCodGlossaryFilterCount();

            this.tempSectionsResult = codSearchResult.aggregations.section.buckets;
            this.tempSectionsResult = this.sectionsResult;
            this.tempSectionsResult = this.tempSectionsResult.sort((first, second) => this.sortAlphaNum(first.key, second.key) ? -1 : 1);
            this.tempContentTypesResult = codSearchResult.aggregations.contentTypes.buckets;
            this.tempContentTypesResult = this.tempContentTypesResult.sort((a, b) => Number(a.key.split(" ")[1]) > Number(b.key.split(" ")[1]) ? 1 : -1);

            if (this.CodTabResultCount > 0) { this.category++; }
            this.codLoaded = true;
            this.setTabCount();
            this.isFullyLoaded = this.role == "Professional" ? this.codLoaded && this.op_cig_loaded && this.annotation_bookmark_loaded : this.codLoaded && this.op_cig_loaded;
            this.outcomeStatus = true;
            this.commonDataService.showLoader.next(false);
          }
        }, err => {
          console.log(err);
          this.commonDataService.showLoader.next(false);
        });

      if (this.role == "Professional") {
        forkJoin(
          this.httpCall.getElasticAnnotation(this.elasticSearchCondition.Searchterm, "", ""),
          this.httpCall.getElasticBookmark(this.elasticSearchCondition.Searchterm, "", "")).subscribe(([annotation, bookmarks]) => {
            this.tempannotationResult = annotation; this.annotationResult = this.tempannotationResult; this.annotationCount = this.tempannotationResult.length;
            this.tempBookmarkResult = bookmarks; this.bookmarkResult = this.tempBookmarkResult; this.bookmarkCount = this.tempBookmarkResult.length;
            this.otherCount = this.annotationCount + this.bookmarkCount;
            this.otherCount = this.annotationCount + this.bookmarkCount;
            this.numberOfResult = this.CodTabResultCount + this.OpTabResultCount + this.CigTabResultCount + this.otherCount;
            this.annotation_bookmark_loaded = true;
            this.isFullyLoaded = this.role == "Professional" ? this.codLoaded && this.op_cig_loaded && this.annotation_bookmark_loaded : this.codLoaded && this.op_cig_loaded;
            this.setTabCount();
            if (this.otherCount > 0) { this.category++; }

            this.httpCall.getRecentSearchTerm().subscribe(recentSearchTerm => {
              this.recentSearchTerm = recentSearchTerm;
            });

          });
      }


      // if (this.role != "Professional") {
      forkJoin(
        this.graphQlService.getOpElasticSearch(this.elasticSearchCondition, this.codPageCount),
        this.graphQlService.getCigElasticSearch(this.elasticSearchCondition, this.codPageCount),
        this.graphQlService.GetMasterGlossarySearch(this.elasticSearchCondition.Searchterm, this.opPageCount, "OP"),
        this.graphQlService.GetMasterGlossarySearch(this.elasticSearchCondition.Searchterm, this.cigPageCount, "CIG")
      ).subscribe(([opSearchResult, cigSearchResult, opGlossary, cigGlossary]) => {

        // this.sectionsResult=codSearchResult.aggregations.section.buckets;
        // this.contentTypeResult=codSearchResult.aggregations.contentTypes.buckets;
        this.pronouncementNumbersResult = opSearchResult?.aggregations?.pronouncementNumbers?.buckets;
        this.documentTypeResult = opSearchResult?.aggregations?.pronouncementTypes?.buckets;
        this.authoritativeTypeResult = opSearchResult?.aggregations?.authoritativeTypes?.buckets;
        this.documentTypeResult = this.documentTypeResult.sort((a, b) => {
          return this.documentTypeList.indexOf(a.key.toString()) - this.documentTypeList.indexOf(b.key.toString());
        });
        this.opGlossaryPrononucementResult = opGlossary?.aggregations?.sourceTypes?.buckets;
        this.chapterResult = cigSearchResult?.aggregations?.chapters?.buckets;
        this.cigGlossaryChapterResult = cigGlossary?.aggregations?.sourceTypes?.buckets;
        const chapterMap: { [key: string]: any } = {};

        // Add all elements from chapterResult to the map
        (this.chapterResult || []).forEach(item => {
          chapterMap[item.key] = { ...item };
        });

        // For each element in cigGlossaryChapterResult, if key exists, add docCount, else add as new
        (this.cigGlossaryChapterResult || []).forEach(item => {
          if (chapterMap[item.key]) {
            chapterMap[item.key].docCount += item.docCount;
          } else {
            chapterMap[item.key] = { ...item };
          }
        });

        // Assign the merged array back to chapterResult
        this.chapterResult = Object.values(chapterMap);
        // Update key from 'gasb_glossaries' to 'Glossary' in cigGlossary?.aggregations?.contentTypes?.buckets
        const cigGlossaryBuckets = cigGlossary?.aggregations?.contentTypes?.buckets || [];
        cigGlossaryBuckets.forEach(bucket => {
          if (bucket.key === 'gasb_glossaries') {
            bucket.key = 'Glossary';
          }
        });
        // Club both arrays and assign to cigContentTypeResult
        this.cigContentTypeResult = [
          ...(cigSearchResult?.aggregations?.contentTypes?.buckets || []),
          ...(cigGlossaryBuckets || [])
        ];
        const desiredOrder = ['Questions and Answers', 'Glossary', 'Nonauthoritative Illustrations'];
        this.cigContentTypeResult = this.cigContentTypeResult.sort((a, b) => {
          const aIndex = desiredOrder.indexOf(a.key);
          const bIndex = desiredOrder.indexOf(b.key);
          if (aIndex !== -1 && bIndex !== -1) {
            return aIndex - bIndex;
          } else if (aIndex !== -1) {
            return -1;
          } else if (bIndex !== -1) {
            return 1;
          } else {
            return a.key.localeCompare(b.key);
          }
        });
        //this.setCigGlossaryFilterCount();

        this.tempPronouncementNumbersResult = opSearchResult?.aggregations?.pronouncementNumbers?.buckets;
        var isChapterZExist = this.chapterResult.find(x => x.key.includes("Chapter Z"));
        if (isChapterZExist) {
          let index = this.chapterResult.indexOf(this.chapterResult.find(x => x.key == "Chapter Z"), 0);
          if (index > -1) {
            this.chapterResult.splice(index, 1);
          }

        }
        this.chapterResult = this.chapterResult.sort((a, b) => {
          return this.sortChapterType(b, a);
        });
        if (isChapterZExist) {
          this.chapterResult.push(isChapterZExist);
        }

        // this.CodSearchResult=codSearchResult.hits?.hitsList; this.CodSearchResultCount=codSearchResult.hits?.hitsList?.length; this.totalCodSearchCount= codSearchResult.hits?.total?.value; this.tempCodSearchResult=this.CodSearchResult;
        this.OpSearchResult = opSearchResult.hits?.hitsList; this.OpSearchResultCount = opSearchResult.hits?.hitsList?.length; this.totalOpSearchCount = opSearchResult.hits?.total?.value; this.tempOpSearchResult = this.OpSearchResult;
        this.CigSearchResult = cigSearchResult.hits?.hitsList;
        this.CigSearchResultCount = cigSearchResult.hits?.hitsList?.length; this.totalCigSearchCount = cigSearchResult.hits?.total?.value; this.tempCigSearchResult = this.CigSearchResult;

        this.OpGlossaryResultCount = opGlossary?.hits?.hitsList?.length; this.opGlossaryResult = this.mapGlossaryContent(opGlossary?.hits?.hitsList, "op"); this.tempopGlossaryResult = this.opGlossaryResult;
        this.CigGlossaryResultCount = cigGlossary?.hits?.hitsList?.length; this.cigGlossaryResult = this.mapGlossaryContent(cigGlossary?.hits?.hitsList, "cig"); this.tempcigGlossaryResult = this.cigGlossaryResult;

        this.totalOpGlossaryCount = opGlossary?.hits?.total?.value; this.OpTabResultCount = this.totalOpSearchCount + this.totalOpGlossaryCount;
        this.totalCigGlossaryCount = cigGlossary?.hits?.total?.value; this.CigTabResultCount = this.totalCigSearchCount + this.totalCigGlossaryCount;

        this.CodResultCount = this.CodSearchResultCount + this.CodGlossaryResultCount;
        this.OpResultCount = this.OpSearchResultCount + this.OpGlossaryResultCount;
        this.CigResultCount = this.CigSearchResultCount + this.CigGlossaryResultCount;

        this.numberOfResult = this.CodTabResultCount + this.OpTabResultCount + this.CigTabResultCount + this.otherCount;
        this.op_cig_loaded = true;
        this.isFullyLoaded = this.role == "Professional" ? this.codLoaded && this.op_cig_loaded && this.annotation_bookmark_loaded : this.codLoaded && this.op_cig_loaded;
        this.setOpGlossaryFilterCount();
        this.setTabCount();

        if (this.OpTabResultCount > 0) { this.category++; }
        if (this.CigTabResultCount > 0) { this.category++; }
        // this.outcomeStatus = true;
        // this.commonDataService.showLoader.next(false);
        this.isFilterLocked = false;
        this.isDropdownLocked = false;
      })
    } else {
      this.outcomeStatus = true;
      this.numberOfResult = 0;
      this.codLoaded = true;
      this.commonDataService.showLoader.next(false);
    }

  }

  setCodGlossaryFilterCount() {

    if (this.codGlossarySectionsResult.length > 0) {
      this.codGlossarySectionsResult.forEach(sections => {
        var keyExists = this.sectionsResult.find(x => x.key == sections.key?.split(" ")[1]);
        if (keyExists) {
          keyExists.docCount += sections.docCount;
        }
        else {
          let obj = {
            key: sections.key?.split(" ")[1],
            docCount: sections.docCount
          }
          this.sectionsResult.push(obj);
        }
      })
      this.sectionsResult = this.sectionsResult.sort((first, second) => this.sortAlphaNum(first.key, second.key) ? -1 : 1);
    }
  }

  setCigGlossaryFilterCount() {
    if (this.cigGlossaryChapterResult.length > 0) {
      this.cigGlossaryChapterResult.forEach(chapters => {
        var keyExists = this.chapterResult.find(x => x.key == chapters.key);
        if (keyExists) {
          keyExists.docCount += chapters.docCount;
        }
        else {
          let obj = {
            key: chapters.key,
            docCount: chapters.docCount
          }
          this.chapterResult.push(obj);
        }
      })
    }
  }

  setOpGlossaryFilterCount() {
    if (this.OpGlossaryResultCount > 0 && this.opGlossaryPrononucementResult.length > 0) {
      if (this.opGlossaryPrononucementResult) {
        this.opGlossaryPrononucementResult.forEach(pronouncement => {
          let documentTypeKeyExists = this.documentTypeResult?.find(x => x.key == pronouncement?.key?.split(" ")[0]);
          let pronouncementNumberKeyExists = this.pronouncementNumbersResult?.find(x => x.key == pronouncement.key);

          if (pronouncementNumberKeyExists) {
            pronouncementNumberKeyExists.docCount += pronouncement.docCount;
          }
          else {
            let obj = {
              key: pronouncement.key,
              docCount: pronouncement.docCount
            }
            this.pronouncementNumbersResult.push(obj);
          }

          if (documentTypeKeyExists) {
            documentTypeKeyExists.docCount += pronouncement.docCount;
          }
          else {
            let obj = {
              key: pronouncement.key.split(" ")[0],
              docCount: pronouncement.docCount
            }

            this.documentTypeResult.push(obj);
          }
        });
      }
    }
  }

  sortAlphaNum(a, b) {
    if (a == "") {
      return true;
    }
    else if (b == "") { return false; }
    else {
      var aA = a.replace(/[0-9]/g, ''); var aAA = parseInt(a.replace(/[A-Za-z]/g, ''));
      var bA = b.replace(/[0-9]/g, ''); var bAA = parseInt(b.replace(/[A-Za-z]/g, ''));
      if ((aA == '' && bA == '') || (aA == bA)) {
        return aAA < bAA;
      } else if (aA != '' && bA == '') {
        return false;
      } else if (aA == '' && bA != '') {
        return true;
      } else {
        let aLen = aA.length;
        let bLen = bA.length;
        if (aLen != bLen) { return aLen < bLen; }
      }
    }
  }

  sortContentType(a, b) {
    if (this.contentTypeList.indexOf(b.key) == -1 && this.contentTypeList.indexOf(a.key) == -1) {
      return a.key > b.key ? -1 : 1
    } else {
      return Number(this.contentTypeList.indexOf(b.key) == -1 ? 100 : this.contentTypeList.indexOf(b.key)) - Number(this.contentTypeList.indexOf(a.key) == -1 ? 100 : this.contentTypeList.indexOf(a.key));
    }
  }
  sortChapterType(a, b) {
    if (this.chapterTypeList.indexOf(b.key) == -1 && this.chapterTypeList.indexOf(a.key) == -1) {
      return a.key > b.key ? -1 : 1
    } else {
      return Number(this.chapterTypeList.indexOf(b.key) == -1 ? 100 : this.chapterTypeList.indexOf(b.key)) - Number(this.chapterTypeList.indexOf(a.key) == -1 ? 100 : this.chapterTypeList.indexOf(a.key));
    }
  }
  setTabCount(TabTitle = "") {
    if (this.codLoaded) {
      if (TabTitle != "") {
        if (TabTitle == "Cod") {
          this.searchTabHeading.filter(x => x.key == "Codification")[0].docCount = this.CodTabResultCount;
        } else if (TabTitle == "Op") {
          this.searchTabHeading.filter(x => x.key == "Original Pronouncements")[0].docCount = this.OpTabResultCount;
        } else if (TabTitle == "Cig") {
          this.searchTabHeading.filter(x => x.key == "Comprehensive Implementation Guide")[0].docCount = this.CigTabResultCount;
        }
      }
      else {
        if (this.searchTabHeading && this.searchTabHeading.length > 0) {

          this.searchTabHeading.forEach(tabHeading => {
            if (tabHeading.key.toLocaleLowerCase().replace(/\s/g, '') == this.originalPronouncements[0].toLocaleLowerCase().replace(/\s/g, '')) {
              tabHeading.docCount = this.OpTabResultCount;
            }
            else if (tabHeading.key.toLocaleLowerCase().replace(/\s/g, '') == this.codification[0].toLocaleLowerCase().replace(/\s/g, '')) {
              tabHeading.docCount = this.CodTabResultCount;
            }
            else if (tabHeading.key.toLocaleLowerCase().replace(/\s/g, '') == this.implementationGuide[0].toLocaleLowerCase().replace(/\s/g, '')) {
              tabHeading.docCount = this.CigTabResultCount;
            }
          })
          var tab1 = this.searchTabHeading[0]?.key.toLocaleLowerCase().replace(/\s/g, '');
          switch (tab1) {
            case this.originalPronouncements[0].toLocaleLowerCase().replace(/\s/g, ''): {
              this.activeTab = "Original Pronouncements";
              break;
            }
            case this.codification[0].toLocaleLowerCase().replace(/\s/g, ''): {
              this.activeTab = "Codification";
              break;
            }
            case this.implementationGuide[0].toLocaleLowerCase().replace(/\s/g, ''): {
              this.activeTab = "Comprehensive Implementation Guide";
              break;
            }
            default: {
              break;
            }
          }
        }
        else {
          if (this.searchTabHeading.length < 3) {
            if (!this.searchTabHeading?.some(x => x.key?.toLocaleLowerCase().includes(("Codification").toLocaleLowerCase()))) {
              let searchTabs = {
                key: this.codification ? this.codification[0] : "Codification",
                docCount: 0
              }
              this.searchTabHeading.push(searchTabs);
            }
            if (!this.searchTabHeading?.some(x => x.key?.toLocaleLowerCase().includes(("Original Pronouncements").toLocaleLowerCase()))) {
              this.searchTabHeading.push({
                key: this.originalPronouncements ? this.originalPronouncements[0] : "Original Pronouncements",
                docCount: 0
              });
            }
            if (!this.searchTabHeading?.some(x => x.key?.toLocaleLowerCase().includes(("Comprehensive Implementation Guide").toLocaleLowerCase()))) {
              this.searchTabHeading.push({
                key: this.implementationGuide ? this.implementationGuide[0] : "Comprehensive Implementation Guide",
                docCount: 0
              });
            }
          }
        }
      }
    }
  }
  NextPageData: any = [];
  result: any = [];
  formattedGlossaryTitle: any = "";
  mapGlossaryContent(data, glossaryType) {
    this.contacts = [];
    if (data != undefined && data.length != 0) {
      data.forEach(element => {
        this.topic = [];
        let source = element.source;
        this.title = source.title == null ? "NA" : source.title;
        let breadcrumbPath = source.levelThree == source.title ? "" : source.levelThree.startsWith(source.levelTwo) ? " ( " + source.levelThree?.split("-")[1] + " )" : " ( " + source.levelThree + " )";
        breadcrumbPath = "<span class='overlay-bread-crumb'>&nbsp;" + breadcrumbPath + "</span>";
        this.title = this.title != "NA" ? this.title + breadcrumbPath : this.title;
        this.formattedGlossaryTitle = source.formattedGlossaryTitle != null ? (source.formattedGlossaryTitle + breadcrumbPath) : this.title;
        this.body = this.domsanitizer.bypassSecurityTrustHtml(element.highlight.exactMatchBody != null ? element.highlight.exactMatchBody[0] : (element.highlight.body != null ? element.highlight.body[0] : source.body));
        if (source.usage != null) {
          source.usage.forEach(usage => {
            this.topic.push(usage);
          });
        }
        var content = { name: this.title, formattedGlossaryTitle: this.formattedGlossaryTitle, capital: this.body, topic: this.topic };
        this.contacts.push(content);
      });
      this.contacts = this.contacts.sort((a, b) => (a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1));
      if (glossaryType == "codification") {
        if (this.codPageCount == 0) {
          this.result = this.contacts;
        }
        else {
          this.NextPageData = this.contacts;
          if (this.NextPageData.length != 0) {
            this.NextPageData.forEach(NewData => {
              this.codGlossaryResult.push(NewData)
            });
          }
          this.result = this.codGlossaryResult;
        }
      }
      else if (glossaryType == "op") {
        if (this.opPageCount == 0) {
          this.result = this.contacts;
        }
        else {
          this.NextPageData = this.contacts;
          if (this.NextPageData.length != 0) {
            this.NextPageData.forEach(NewData => {
              this.opGlossaryResult.push(NewData)
            });
          }
          this.result = this.opGlossaryResult;
        }
      }
      else {
        if (this.cigPageCount == 0) {
          this.result = this.contacts;
        }
        else {
          this.NextPageData = this.contacts;
          if (this.NextPageData.length != 0) {
            this.NextPageData.forEach(NewData => {
              this.cigGlossaryResult.push(NewData)
            });
          }
          this.result = this.cigGlossaryResult;
        }
      }

      return this.result;

    }
  }

  loadNextPage(glossaryType: string) {
    if (glossaryType == 'glossary_codification') {
      this.codPageCount = this.codPageCount + 1;
      if (this.totalCodSearchCount > this.CodSearchResultCount) {
        this.graphQlService.getCodElasticSearch(this.elasticSearchCondition, this.codPageCount).subscribe(codSearchRes => {
          this.CodSearchResult = this.CodSearchResult.concat(codSearchRes.hits?.hitsList);
          this.tempCodSearchResult = this.CodSearchResult;
          this.CodSearchResultCount = this.CodSearchResultCount + codSearchRes.hits?.hitsList?.length;
          this.CodResultCount = this.CodSearchResultCount + this.CodGlossaryResultCount;
          this.getCodFilter();
          this.setTabCount("Cod");
        })
      }
      if (this.totalCodGlossaryCount > this.CodGlossaryResultCount) {
        this.graphQlService.GetMasterGlossarySearchFilter(this.elasticSearchCondition.Searchterm, this.codPageCount, "COD", this.elasticSearchCondition.Section, this.elasticSearchCondition.ContentType).subscribe(codGlossary => {
          this.CodGlossaryResultCount = this.CodGlossaryResultCount + codGlossary?.hits?.hitsList?.length;
          this.codGlossaryResult = this.mapGlossaryContent(codGlossary?.hits?.hitsList, "codification");
          this.tempcodGlossaryResult = this.codGlossaryResult;
          this.CodResultCount = this.CodSearchResultCount + this.CodGlossaryResultCount;
          this.getCodFilter();
          this.setTabCount("Cod");
        })
      }
    }
    else if (glossaryType == 'glossary_op') {
      this.opPageCount = this.opPageCount + 1;
      if (this.totalOpSearchCount > this.OpSearchResultCount) {
        this.graphQlService.getOpElasticSearch(this.elasticSearchCondition, this.opPageCount).subscribe(OpSearchRes => {
          this.OpSearchResult = this.OpSearchResult.concat(OpSearchRes.hits?.hitsList);
          this.OpSearchResultCount = this.OpSearchResultCount + OpSearchRes.hits?.hitsList?.length;
          this.tempOpSearchResult = this.OpSearchResult;
          this.OpResultCount = this.OpSearchResultCount + this.OpGlossaryResultCount;
          this.getOpFilter();
          this.setTabCount("Op");
        })
      }
      if (this.totalOpGlossaryCount > this.OpGlossaryResultCount) {
        this.graphQlService.GetMasterGlossarySearchFilter(this.elasticSearchCondition.Searchterm, this.opPageCount, "OP", this.GlossaryPronouncementFilter, []).subscribe(opGlossary => {
          this.OpGlossaryResultCount = this.OpGlossaryResultCount + opGlossary?.hits?.hitsList?.length;
          this.opGlossaryResult = this.mapGlossaryContent(opGlossary?.hits?.hitsList, "op");
          this.tempopGlossaryResult = this.opGlossaryResult
          this.OpResultCount = this.OpSearchResultCount + this.OpGlossaryResultCount;
          this.getOpFilter();
          this.setTabCount("Op");
        })
      }

    }
    else {
      this.cigPageCount = this.cigPageCount + 1;

      if (this.totalCigSearchCount > this.CigSearchResultCount) {
        this.graphQlService.getCigElasticSearch(this.elasticSearchCondition, this.cigPageCount).subscribe(cigSearchRes => {
          this.CigSearchResult = this.CigSearchResult.concat(this.selectedCigFilters.length > 0 ? cigSearchRes.hits?.hitsList?.filter(a => this.selectedCigFilters.some(filter => filter.includes(a.source?.levelThree))) : cigSearchRes.hits?.hitsList);
          this.CigSearchResultCount = this.CigSearchResultCount + cigSearchRes.hits?.hitsList?.length;
          this.tempCigSearchResult = this.CigSearchResult;
          this.CigResultCount = this.CigSearchResultCount + this.CigGlossaryResultCount;
          this.getCigFilter();
          this.setTabCount("Cig");
        })
      }
      if (this.totalCigGlossaryCount > this.CigGlossaryResultCount) {
        this.graphQlService.GetMasterGlossarySearchFilter(this.elasticSearchCondition.Searchterm, this.cigPageCount, "CIG", this.elasticSearchCondition.Chapter, this.elasticSearchCondition.CIGContentType).subscribe(cigGlossary => {
          this.CigGlossaryResultCount = this.CigGlossaryResultCount + cigGlossary?.hits?.hitsList?.length;
          this.cigGlossaryResult = this.mapGlossaryContent(this.selectedCigFilters.length > 0 ? cigGlossary?.hits?.hitsList?.filter(a => a.source?.levelOne.includes("gasb_glossaries")) : cigGlossary?.hits?.hitsList, "cig");
          this.tempcigGlossaryResult = this.cigGlossaryResult;
          this.CigResultCount = this.CigSearchResultCount + this.CigGlossaryResultCount;
          this.getCigFilter();
          this.setTabCount("Cig");
        })
      }

    }

  }

  redirectToBookmarkUrl(bookmark) {
    window.open(bookmark.bookmarkURL);
  }

  redirectToAnnotationUrl(annotation) {
    window.open(annotation.annotationsURL)
  }

  searchContent(evt, searchValue) {
    searchValue = searchValue.toLocaleLowerCase().replace(/\s/g, '');
    this.commonDataService.showLoader.next(true);
    
    if (searchValue == this.originalPronouncements[0].toLocaleLowerCase().replace(/\s/g, '')) {
      this.activeTab = "Original Pronouncements";
      this.selectedDocumentType.forEach(x => {
        let index = this.documentTypeResult.findIndex((obj => obj.key == x));
        this.documentTypeResult[index].checked = true;
      })
    }
    else if (searchValue == this.codification[0].toLocaleLowerCase().replace(/\s/g, '')) {
      this.activeTab = "Codification";
      this.selectedContentType.forEach(x => {
        let index = this.contentTypeResult.findIndex((obj => obj.key == x));
        this.contentTypeResult[index].checked = true;
      })

    }
    else if (searchValue == this.implementationGuide[0].toLocaleLowerCase().replace(/\s/g, '')) {
      this.activeTab = "Comprehensive Implementation Guide";
      this.selectedChapter.forEach(x => {
        let index = this.chapterResult.findIndex((obj => obj.key == x));
        this.chapterResult[index].checked = true;
      })
    }
    else if (searchValue == "other") {
      this.activeTab = "otherTab";

    }
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("glossaryTabContent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
   
    if (document.getElementById("myButton") != null) {
      document.getElementById("myButton").style.display = "block";
    }
    evt.currentTarget.className += " active";
    this.commonDataService.showLoader.next(false);
    this.EnableBackToTop();
  }

  checkedChapter(event) {
    this.commonDataService.showLoader.next(true);
    this.cigPageCount = 0;
    if (event.checked) {
      this.selectedChapter.push(event.source.value);
    }
    else {
      this.selectedChapter.forEach((value, index) => {
        if (value == event.source.value) {
          this.selectedChapter.splice(index, 1);
        }
      });
    }

    this.elasticSearchCondition.Chapter = this.selectedChapter;
    const updatedCigFilters = this.selectedCigFilters.map(f => f === "Glossary" ? "gasb_glossaries" : f);
    this.elasticSearchCondition.CIGContentType = updatedCigFilters;
    let elasticSearchConditionForAggregation = {
      Searchterm: this.elasticSearchCondition.Searchterm,
      // SourceType: "",
      Chapter: this.selectedChapter,
      DocumentType: [],
      ContentType: [],
      Section: [],
      PageNumber: this.elasticSearchCondition.PageNumber,
      PronouncementType: [],
      AuthoritativeType: [],
      CIGContentType: []
    };
    forkJoin(this.graphQlService.getCigElasticSearch(this.elasticSearchCondition, this.cigPageCount), this.graphQlService.getCigElasticSearch(elasticSearchConditionForAggregation, this.cigPageCount),
      this.graphQlService.GetMasterGlossarySearchFilter(this.elasticSearchCondition.Searchterm, 0, "CIG", this.elasticSearchCondition.Chapter, this.elasticSearchCondition.CIGContentType),
      this.graphQlService.GetMasterGlossarySearchFilter(this.elasticSearchCondition.Searchterm, 0, "CIG", this.elasticSearchCondition.Chapter, [])).
      subscribe(([cigRes, cigResAggregation, CigGlossaryRes, CigGlossaryResAggregation]) => {
        /*  this.CigSearchResult = cigRes.hits?.hitsList;*/
        this.CigSearchResult = this.selectedCigFilters.length > 0 ? cigRes.hits?.hitsList?.filter(a => this.selectedCigFilters.some(filter => a.source?.levelThree != null && a.source.levelThree?.includes(filter))) : cigRes.hits?.hitsList;
        this.totalCigSearchCount = cigRes.hits?.total?.value;
        this.CigSearchResultCount = cigRes.hits?.hitsList?.length;
        this.CigTabResultCount = this.totalCigSearchCount + this.totalCigGlossaryCount;
        this.CigResultCount = this.CigSearchResultCount + this.CigGlossaryResultCount;
        this.CigGlossaryResultCount = CigGlossaryRes?.hits?.hitsList?.length;
        //this.cigGlossaryResult = this.mapGlossaryContent(CigGlossaryRes?.hits?.hitsList, "cig");
        this.cigGlossaryResult = this.mapGlossaryContent(this.selectedCigFilters.length > 0 && this.selectedCigFilters.includes("Glossary") ? CigGlossaryRes?.hits?.hitsList?.filter(a => a.source?.levelOne != null && a.source.levelOne?.includes("gasb_glossaries")) : CigGlossaryRes?.hits?.hitsList, "cig");
        if (this.selectedCigFilters.length > 0 && !(this.selectedCigFilters.includes("Glossary"))) {
          this.cigGlossaryResult = [];
        }
        const cigGlossaryBuckets = CigGlossaryRes?.aggregations?.contentTypes?.buckets || [];
        cigGlossaryBuckets.forEach(bucket => {
          if (bucket.key === 'gasb_glossaries') {
            bucket.key = 'Glossary';
          }
        });
        const chapterMap: { [key: string]: any } = {};
        (cigRes?.aggregations?.chapters?.buckets || []).forEach(item => {
          chapterMap[item.key] = { ...item };
        });
        if ((this.selectedCigFilters.includes("Glossary")) || (this.selectedCigFilters.length == 0)) {
          (CigGlossaryRes?.aggregations?.sourceTypes?.buckets || []).forEach(item => {
            if (chapterMap[item.key]) {
              chapterMap[item.key].docCount += item.docCount;
            } else {
              chapterMap[item.key] = { ...item };
            }
          });
        }
        this.chapterResult = Object.values(chapterMap);
        var isChapterZExist = this.chapterResult.find(x => x.key.includes("Chapter Z"));
        if (isChapterZExist) {
          let index = this.chapterResult.indexOf(this.chapterResult.find(x => x.key == "Chapter Z"), 0);
          if (index > -1) {
            this.chapterResult.splice(index, 1);
          }

        }
        this.chapterResult = this.chapterResult.sort((a, b) => {
          return this.sortChapterType(b, a);
        });
        if (isChapterZExist) {
          this.chapterResult.push(isChapterZExist);
        }

        const cigGlossaryBucketsForAggregation = CigGlossaryResAggregation?.aggregations?.contentTypes?.buckets || [];
        cigGlossaryBucketsForAggregation.forEach(bucket => {
          if (bucket.key === 'gasb_glossaries') {
            bucket.key = 'Glossary';
          }
        });

        this.cigContentTypeResult = [
          ...(cigResAggregation?.aggregations?.contentTypes?.buckets || []),
          ...(cigGlossaryBucketsForAggregation || [])
        ];
        const desiredOrder = ['Questions and Answers', 'Glossary', 'Nonauthoritative Illustrations'];
        this.cigContentTypeResult = this.cigContentTypeResult.sort((a, b) => {
          const aIndex = desiredOrder.indexOf(a.key);
          const bIndex = desiredOrder.indexOf(b.key);
          if (aIndex !== -1 && bIndex !== -1) {
            return aIndex - bIndex;
          } else if (aIndex !== -1) {
            return -1;
          } else if (bIndex !== -1) {
            return 1;
          } else {
            return a.key.localeCompare(b.key);
          }
        });
        this.totalCigGlossaryCount = CigGlossaryRes?.hits?.total?.value;
        this.CigTabResultCount = this.totalCigSearchCount + this.totalCigGlossaryCount;
        this.getCigFilter();
        this.setTabCount("Cig");

        this.cigSectionFilter = this.FILTER_ARRAY.filter(item => this.CigSearchResult.some(csr => csr?.source?.levelThree?.includes(item.key)) || CigGlossaryRes?.hits?.hitsList?.some(cgr => cgr?.source?.levelOne?.includes(item.key) || cgr?.source?.levelOne?.includes("gasb_glossaries")));
        this.cigFilterExists = (this.selectedChapter.length > 0 || this.cigGlossaryChecked) ? true : false;
        this.commonDataService.showLoader.next(false);
      });
  }

  checkedGlossaryTerm(event, glossaryType) {
    if (event.checked) {
      if (glossaryType == "cod") {
        this.codGlossaryResult = this.tempcodGlossaryResult;
        if (this.selectedContentType.length == 0 && this.SelectedSection.length == 0) {
          this.CodTabResultCount = this.totalCodGlossaryCount;
          this.CodResultCount = this.CodGlossaryResultCount;
          this.CodSearchResult = [];
        }
        this.codFilterExists = true;
        this.codGlossaryChecked = true;
        this.getCodFilter();
        this.setTabCount("Cod");
      }
      else if (glossaryType == "op") {
        this.opGlossaryResult = this.tempopGlossaryResult;
        this.opFilterExists = true;
        this.opGlossaryChecked = true;
        if (this.selectedDocumentType.length == 0 && this.SelectedPronouncement.length == 0) {
          this.OpTabResultCount = this.totalOpGlossaryCount;
          this.OpResultCount = this.OpGlossaryResultCount;
          this.OpSearchResult = [];
        }
        this.getOpFilter();
        this.setTabCount("Op");
      }
      else {
        this.cigGlossaryResult = this.tempcigGlossaryResult;
        if (this.selectedChapter.length == 0) {
          this.CigTabResultCount = this.totalCigGlossaryCount;
          this.CigResultCount = this.CigGlossaryResultCount;
          this.CigSearchResult = [];
        }
        this.cigFilterExists = true;
        this.cigGlossaryChecked = true;
        this.getCigFilter();
        this.setTabCount("Cig");
      }
    }
    else {
      if (glossaryType == "cod") {
        if (this.selectedContentType.length == 0 && this.SelectedSection.length == 0) {
          this.CodSearchResult = this.tempCodSearchResult;
          this.codGlossaryResult = this.tempcodGlossaryResult;
        }
        else {
          this.codGlossaryResult = [];
        }

        this.codFilterExists = (this.selectedContentType.length > 0 || this.SelectedSection.length > 0) ? true : false;
        this.codGlossaryChecked = false;
        this.getCodFilter();
        this.setTabCount("Cod");
      }
      else if (glossaryType == "op") {
        if (this.selectedDocumentType.length == 0 && this.SelectedPronouncement.length == 0) {
          this.OpSearchResult = this.tempOpSearchResult;
          this.opGlossaryResult = this.tempopGlossaryResult;
        } else {
          this.opGlossaryResult = [];
        }

        this.opFilterExists = (this.selectedDocumentType.length > 0) ? true : false;
        this.opGlossaryChecked = false;
        this.getOpFilter();
        this.setTabCount("Op");
      }
      else {

        if (this.selectedChapter.length == 0) {
          this.cigGlossaryResult = this.tempcigGlossaryResult;
          this.CigSearchResult = this.tempCigSearchResult;
        } else {
          this.cigGlossaryResult = [];
        }
        this.cigFilterExists = (this.selectedChapter.length > 0) ? true : false;
        this.cigGlossaryChecked = false;
        this.getCigFilter();
        this.setTabCount("Cig");
      }
    }
  }

  checkedContentType(event) {
    this.codPageCount = 0;
    if (event.checked) {
      this.selectedContentType.push(event.source.value);
    }
    else {
      this.selectedContentType.forEach((value, index) => {
        if (value == event.source.value) {
          this.selectedContentType.splice(index, 1);
        }
      });
    }

    this.codFilterExists = (this.SelectedSection.length > 0 || this.selectedContentType.length > 0) ? true : false;
    this.elasticSearchCondition.ContentType = this.selectedContentType;
    forkJoin(this.graphQlService.getCodElasticSearch(this.elasticSearchCondition, 0), this.graphQlService.GetMasterGlossarySearchFilter(this.elasticSearchCondition.Searchterm, 0, "COD", this.elasticSearchCondition.Section, this.elasticSearchCondition.ContentType)).
      subscribe(([codRes, CodGlossaryRes]) => {
        if (codRes) {
          this.CodSearchResult = codRes.hits?.hitsList;
          this.totalCodSearchCount = codRes.hits?.total?.value;
          this.CodSearchResultCount = codRes.hits?.hitsList?.length;
          this.sectionsResult = codRes.aggregations.section.buckets;


          this.contentTypeResult = codRes.aggregations.contentTypes.buckets;
          this.contentTypeResult = this.contentTypeResult.sort((a, b) => {
            return this.sortContentType(b, a);
          });

          this.CodGlossaryResultCount = CodGlossaryRes?.hits?.hitsList?.length;
          this.codGlossaryResult = this.mapGlossaryContent(CodGlossaryRes?.hits?.hitsList, "codification");
          this.totalCodGlossaryCount = CodGlossaryRes?.hits?.total?.value;
          this.CodTabResultCount = this.totalCodSearchCount + this.totalCodGlossaryCount;

          if (this.contentTypeResult.filter(x => x.key == "Definitions").length > 0) {
            var defcount = this.contentTypeResult.filter(x => x.key == "Definitions").map(y => y.docCount)[0];
            var totaldefcount = defcount + this.totalCodGlossaryCount
            this.contentTypeResult.filter(u => u.docCount = (u.key == "Definitions" ? totaldefcount : u.docCount))
            this.codGlossaryChecked = true;
          }
          else if ((this.totalCodGlossaryCount > 0 && this.selectedContentType.length > 0 && this.selectedContentType.includes("Definitions")) || (this.totalCodGlossaryCount > 0 && this.selectedContentType.length == 0)) {
            this.contentTypeResult.push({ key: "Definitions", docCount: 0 })
            this.contentTypeResult.map(u => u.docCount = (u.key == "Definitions" ? this.totalCodGlossaryCount : u.docCount));
            this.codGlossaryChecked = true;
          }
          this.getCodFilter(codRes.aggregations);
          this.setTabCount("Cod");
        }
      });

  }

  checkedAuthtype(event) {
    this.opPageCount = 0;
    if (event.checked) {
      this.selectedAuthType.push(event.source.value);
      if (this.GlossaryPronouncementFilter.filter(x => x.startsWith(event.source.value) || x == event.source.value).length == 0) {
        this.GlossaryPronouncementFilter.push(event.source.value);
      }
    }
    else {
      this.selectedAuthType.forEach((value, index) => {
        if (value == event.source.value) {
          this.selectedAuthType.splice(index, 1);
        }
      });
      let sourceIndex = this.GlossaryPronouncementFilter.findIndex(y => y == event.source.value);
      if (sourceIndex > -1) {
        this.GlossaryPronouncementFilter.splice(sourceIndex, 1);
      }
    }
    this.opFilterExists = (this.selectedAuthType.length > 0 || this.opGlossaryChecked) ? true : false;
    this.elasticSearchCondition.AuthoritativeType = this.selectedAuthType;
    // this.graphQlService.getOpElasticSearch(this.elasticSearchCondition,this.opPageCount).subscribe(opRes => { 
    //   if(opRes)
    //   {
    //     this.OpSearchResult = opRes.hits?.hitsList; 
    //     this.totalOpSearchCount=opRes.hits?.total?.value;
    //     this.OpSearchResultCount=opRes.hits?.hitsList?.length;

    //     if(this.opGlossaryChecked && this.selectedDocumentType.length==0){
    //       this.opGlossaryResult=this.tempopGlossaryResult;
    //       this.OpSearchResult=[];
    //     }
    //     else if(!this.opGlossaryChecked && this.selectedDocumentType.length==0){
    //       this.opGlossaryResult=this.tempopGlossaryResult;
    //     }
    //     else if(!this.opGlossaryChecked && this.selectedDocumentType.length>0){
    //       this.opGlossaryResult=[];
    //     }

    //     this.OpTabResultCount=this.totalOpSearchCount+this.totalOpGlossaryCount;
    //     this.OpResultCount=this.OpSearchResultCount+this.OpGlossaryResultCount;
    //     this.getOpFilter(opRes.aggregations);
    //     this.setTabCount("Op");
    //   }
    //   });
    forkJoin(this.graphQlService.getOpElasticSearch(this.elasticSearchCondition, 0), this.graphQlService.GetMasterGlossarySearchFilter(this.elasticSearchCondition.Searchterm, 0, "OP", this.GlossaryPronouncementFilter, [])).
      subscribe(([opRes, OpGlossaryRes]) => {
        this.OpSearchResult = opRes.hits?.hitsList;
        this.totalOpSearchCount = opRes.hits?.total?.value;
        this.OpSearchResultCount = opRes.hits?.hitsList?.length;

        this.OpGlossaryResultCount = OpGlossaryRes?.hits?.hitsList?.length;
        this.opGlossaryResult = this.mapGlossaryContent(OpGlossaryRes?.hits?.hitsList, "op");
        this.totalOpGlossaryCount = OpGlossaryRes?.hits?.total?.value;
        this.OpTabResultCount = this.totalOpSearchCount + this.totalOpGlossaryCount;
        this.pronouncementNumbersResult = [];
        if (this.elasticSearchCondition.DocumentType.length > 0) {
          this.elasticSearchCondition.DocumentType.forEach(docType => {
            if (this.tempPronouncementNumbersResult.filter(x => x.key.split(" ")[0] == docType).length > 0) {
              this.tempPronouncementNumbersResult.filter(x => x.key.split(" ")[0] == docType).forEach(x => {
                this.pronouncementNumbersResult.push(x);
              })

            }
          })
        }
        else {
          this.pronouncementNumbersResult = this.tempPronouncementNumbersResult;
        }
        this.getOpFilter(opRes.aggregations); this.setTabCount("Op");
      })
  }

  checkedDocumentType(event) {
    this.opPageCount = 0;
    if (event.checked) {
      this.selectedDocumentType.push(event.source.value);
      if (this.GlossaryPronouncementFilter.filter(x => x.startsWith(event.source.value) || x == event.source.value).length == 0) {
        this.GlossaryPronouncementFilter.push(event.source.value);
      }
    }
    else {
      this.selectedDocumentType.forEach((value, index) => {
        if (value == event.source.value) {
          this.selectedDocumentType.splice(index, 1);
        }
      });
      let sourceIndex = this.GlossaryPronouncementFilter.findIndex(y => y == event.source.value);
      if (sourceIndex > -1) {
        this.GlossaryPronouncementFilter.splice(sourceIndex, 1);
      }
    }
    this.opFilterExists = (this.selectedDocumentType.length > 0 || this.opGlossaryChecked) ? true : false;
    this.elasticSearchCondition.DocumentType = this.selectedDocumentType;
    // this.graphQlService.getOpElasticSearch(this.elasticSearchCondition,this.opPageCount).subscribe(opRes => { 
    //   if(opRes)
    //   {
    //     this.OpSearchResult = opRes.hits?.hitsList; 
    //     this.totalOpSearchCount=opRes.hits?.total?.value;
    //     this.OpSearchResultCount=opRes.hits?.hitsList?.length;

    //     if(this.opGlossaryChecked && this.selectedDocumentType.length==0){
    //       this.opGlossaryResult=this.tempopGlossaryResult;
    //       this.OpSearchResult=[];
    //     }
    //     else if(!this.opGlossaryChecked && this.selectedDocumentType.length==0){
    //       this.opGlossaryResult=this.tempopGlossaryResult;
    //     }
    //     else if(!this.opGlossaryChecked && this.selectedDocumentType.length>0){
    //       this.opGlossaryResult=[];
    //     }

    //     this.OpTabResultCount=this.totalOpSearchCount+this.totalOpGlossaryCount;
    //     this.OpResultCount=this.OpSearchResultCount+this.OpGlossaryResultCount;
    //     this.getOpFilter(opRes.aggregations);
    //     this.setTabCount("Op");
    //   }
    //   });
    forkJoin(this.graphQlService.getOpElasticSearch(this.elasticSearchCondition, 0), this.graphQlService.GetMasterGlossarySearchFilter(this.elasticSearchCondition.Searchterm, 0, "OP", this.GlossaryPronouncementFilter, [])).
      subscribe(([opRes, OpGlossaryRes]) => {
        this.OpSearchResult = opRes.hits?.hitsList;
        this.totalOpSearchCount = opRes.hits?.total?.value;
        this.OpSearchResultCount = opRes.hits?.hitsList?.length;

        this.OpGlossaryResultCount = OpGlossaryRes?.hits?.hitsList?.length;
        this.opGlossaryResult = this.mapGlossaryContent(OpGlossaryRes?.hits?.hitsList, "op");
        this.totalOpGlossaryCount = OpGlossaryRes?.hits?.total?.value;
        this.OpTabResultCount = this.totalOpSearchCount + this.totalOpGlossaryCount;
        this.pronouncementNumbersResult = [];
        if (this.elasticSearchCondition.DocumentType.length > 0) {
          // this.elasticSearchCondition.DocumentType.forEach(docType=>{
          //   if(this.tempPronouncementNumbersResult.filter(x=>x.key.split(" ")[0]==docType).length>0){
          //     this.tempPronouncementNumbersResult.filter(x=>x.key.split(" ")[0]==docType).forEach(x=>{
          //       this.pronouncementNumbersResult.push(x);
          //     })

          //   }
          // })
        }
        else {
          this.pronouncementNumbersResult = this.tempPronouncementNumbersResult;
        }
        this.getOpFilter(opRes.aggregations); this.setTabCount("Op");
      })
  }

  selectedSection() {
    this.codPageCount = 0;
    var isSectionExists = this.SelectedSection.includes(this.sections.value);
    if (!isSectionExists) {
      this.SelectedSection.push(this.sections.value);
    }
    this.elasticSearchCondition.Section = this.SelectedSection;
    this.sections.setValue('');

    this.codFilterExists = (this.SelectedSection.length > 0 || this.selectedContentType.length > 0 || this.codGlossaryChecked) ? true : false;
    if (!isSectionExists) {
      forkJoin(this.graphQlService.getCodElasticSearch(this.elasticSearchCondition, 0), this.graphQlService.GetMasterGlossarySearchFilter(this.elasticSearchCondition.Searchterm, 0, "COD", this.elasticSearchCondition.Section, this.elasticSearchCondition.ContentType)).
        subscribe(([codRes, CodGlossaryRes]) => {
          this.CodSearchResult = codRes.hits?.hitsList;
          this.totalCodSearchCount = codRes.hits?.total?.value;
          this.CodSearchResultCount = codRes.hits?.hitsList?.length;
          this.contentTypeResult = codRes.aggregations.contentTypes.buckets;
          this.contentTypeResult = this.contentTypeResult.sort((a, b) => {
            return this.sortContentType(b, a);
          });

          this.CodGlossaryResultCount = CodGlossaryRes != null ? (CodGlossaryRes?.hits?.hitsList?.length) : 0;
          this.codGlossaryResult = this.mapGlossaryContent(CodGlossaryRes?.hits?.hitsList, "codification");
          this.totalCodGlossaryCount = CodGlossaryRes != null ? (CodGlossaryRes?.hits?.total?.value) : 0;
          this.CodTabResultCount = this.totalCodSearchCount + this.totalCodGlossaryCount;
          if (this.contentTypeResult.filter(x => x.key == "Definitions").length > 0) {
            var defcount = this.contentTypeResult.filter(x => x.key == "Definitions").map(y => y.docCount)[0];
            var totaldefcount = defcount + this.totalCodGlossaryCount
            this.contentTypeResult.filter(u => u.docCount = (u.key == "Definitions" ? totaldefcount : u.docCount))
            this.codGlossaryChecked = true;
          }
          else if ((this.totalCodGlossaryCount > 0 && this.selectedContentType.length > 0 && this.selectedContentType.includes("Definitions")) || (this.totalCodGlossaryCount > 0 && this.selectedContentType.length == 0)) {
            this.contentTypeResult.push({ key: "Definitions", docCount: 0 })
            this.contentTypeResult.map(u => u.docCount = (u.key == "Definitions" ? this.totalCodGlossaryCount : u.docCount));
            this.codGlossaryChecked = true;
          }
          this.getCodFilter(codRes.aggregations); this.setTabCount("Cod");
        })
    }
  }


  RemoveSection(sectionValue) {
    this.codPageCount = 0;
    var isSectionExists = this.SelectedSection.includes(sectionValue);
    if (isSectionExists) {
      this.SelectedSection.forEach((value, index) => {
        if (value == sectionValue) {
          this.SelectedSection.splice(index, 1);
        }
      });
    }
    this.codFilterExists = (this.SelectedSection.length > 0 || this.selectedContentType.length > 0 || this.codGlossaryChecked) ? true : false;
    this.elasticSearchCondition.Section = this.SelectedSection;

    forkJoin(this.graphQlService.getCodElasticSearch(this.elasticSearchCondition, 0), this.graphQlService.GetMasterGlossarySearchFilter(this.elasticSearchCondition.Searchterm, 0, "COD", this.elasticSearchCondition.Section, this.elasticSearchCondition.ContentType)).
      subscribe(([codRes, CodGlossaryRes]) => {
        this.CodSearchResult = codRes.hits?.hitsList;
        this.totalCodSearchCount = codRes.hits?.total?.value;
        this.CodSearchResultCount = codRes.hits?.hitsList?.length;
        this.contentTypeResult = codRes?.aggregations?.contentTypes?.buckets;

        this.contentTypeResult = this.contentTypeResult.sort((a, b) => {
          return this.sortContentType(b, a);
        });

        this.CodGlossaryResultCount = CodGlossaryRes != null ? (CodGlossaryRes?.hits?.hitsList?.length) : 0;
        this.codGlossaryResult = this.mapGlossaryContent(CodGlossaryRes?.hits?.hitsList, "codification");
        this.totalCodGlossaryCount = CodGlossaryRes != null ? (CodGlossaryRes?.hits?.total?.value) : 0;
        this.CodTabResultCount = this.totalCodSearchCount + this.totalCodGlossaryCount;

        if (this.contentTypeResult.filter(x => x.key == "Definitions").length > 0) {
          var defcount = this.contentTypeResult.filter(x => x.key == "Definitions").map(y => y.docCount)[0];
          var totaldefcount = defcount + this.totalCodGlossaryCount
          this.contentTypeResult.filter(u => u.docCount = (u.key == "Definitions" ? totaldefcount : u.docCount))
          this.codGlossaryChecked = true;
        }
        else if (this.totalCodGlossaryCount > 0) {
          this.contentTypeResult.push({ key: "Definitions", docCount: 0 })
          this.contentTypeResult.map(u => u.docCount = (u.key == "Definitions" ? this.totalCodGlossaryCount : u.docCount));
          this.codGlossaryChecked = true;
        }
        if (this.SelectedSection.length == 0) {
          this.sectionsResult = codRes?.aggregations?.section?.buckets;
        }

        this.getCodFilter(codRes.aggregations); this.setTabCount("Cod");
      })
  }

  GlossaryPronouncementFilter: any = [];
  SelectedPronouncementNumber() {
    var pronouncementNumberExists = this.SelectedPronouncement.includes(this.pronouncementNumber.value);
    if (!pronouncementNumberExists) {
      this.SelectedPronouncement.push(this.pronouncementNumber.value);
    }
    this.elasticSearchCondition.PronouncementType = this.SelectedPronouncement;
    this.pronouncementNumber.setValue('');

    this.SelectedPronouncement.forEach(x => {
      let index = this.GlossaryPronouncementFilter.findIndex(y => y == x.split(" ")[0]);
      if (index > -1) {
        this.GlossaryPronouncementFilter.splice(index, 1);
      }
      if (!this.GlossaryPronouncementFilter.includes(x)) {
        this.GlossaryPronouncementFilter.push(x);
      }
    })
    if (!pronouncementNumberExists) {
      forkJoin(this.graphQlService.getOpElasticSearch(this.elasticSearchCondition, 0), this.graphQlService.GetMasterGlossarySearchFilter(this.elasticSearchCondition.Searchterm, 0, "OP", this.GlossaryPronouncementFilter, [])).
        subscribe(([opRes, OpGlossaryRes]) => {
          this.OpSearchResult = opRes.hits?.hitsList;
          this.totalOpSearchCount = opRes.hits?.total?.value;
          this.OpSearchResultCount = opRes.hits?.hitsList?.length;

          this.OpGlossaryResultCount = OpGlossaryRes?.hits?.hitsList?.length;
          this.opGlossaryResult = this.mapGlossaryContent(OpGlossaryRes?.hits?.hitsList, "op");
          this.totalOpGlossaryCount = OpGlossaryRes?.hits?.total?.value;
          this.OpTabResultCount = this.totalOpSearchCount + this.totalOpGlossaryCount;
          this.getOpFilter(opRes.aggregations); this.setTabCount("Op");
        })
    }
  }

  onFilterSelectionRemoved(st: string) {
    this.commonDataService.showLoader.next(true);
    this.selectedType = "";
    this.cigPageCount = 0;
    this.cigFilterExists = (this.selectedChapter.length > 0 || this.cigGlossaryChecked) ? true : false;
    this.elasticSearchCondition.Chapter = this.selectedChapter;
    if (this.selectedCigFilters.includes(st)) {
      this.selectedCigFilters = this.selectedCigFilters.filter(a => a != st);
    }
    // Before assigning to elasticSearchCondition.ContentType, replace "Glossary" with "gasb_glossaries" in selectedCigFilters
    const updatedCigFilters = this.selectedCigFilters.map(f => f === "Glossary" ? "gasb_glossaries" : f);
    this.elasticSearchCondition.CIGContentType = updatedCigFilters;
    let elasticSearchConditionForAggregation = {
      Searchterm: this.elasticSearchCondition.Searchterm,
      // SourceType: "",
      Chapter: this.selectedChapter,
      DocumentType: [],
      ContentType: [],
      Section: [],
      PageNumber: this.elasticSearchCondition.PageNumber,
      PronouncementType: [],
      AuthoritativeType: [],
      CIGContentType: []
    };
    forkJoin(this.graphQlService.getCigElasticSearch(this.elasticSearchCondition, this.cigPageCount), this.graphQlService.getCigElasticSearch(elasticSearchConditionForAggregation, this.cigPageCount),
      this.graphQlService.GetMasterGlossarySearchFilter(this.elasticSearchCondition.Searchterm, 0, "CIG", this.elasticSearchCondition.Chapter, this.elasticSearchCondition.CIGContentType),
      this.graphQlService.GetMasterGlossarySearchFilter(this.elasticSearchCondition.Searchterm, 0, "CIG", this.elasticSearchCondition.Chapter, [])).
      subscribe(([cigRes, cigResAggregation, CigGlossaryRes, CigGlossaryResAggregation]) => {
        if (this.selectedCigFilters.includes("Glossary") || this.selectedCigFilters.length == 0) {
          this.CigSearchResult = cigRes.hits?.hitsList?.filter(a => a.source.levelThree?.includes("gasb_glossaries"));
          this.totalCigSearchCount = cigRes.hits?.total?.value;
          this.CigSearchResultCount = cigRes.hits?.hitsList?.length;
          this.CigTabResultCount = this.totalCigSearchCount + this.totalCigGlossaryCount;
          this.CigResultCount = this.CigSearchResultCount + this.CigGlossaryResultCount;
          this.CigGlossaryResultCount = CigGlossaryRes?.hits?.hitsList?.length;
          this.cigGlossaryResult = this.mapGlossaryContent(this.selectedCigFilters.length > 0 ? CigGlossaryRes?.hits?.hitsList?.filter(a => a.source?.levelOne != null && a.source.levelOne?.includes("gasb_glossaries")) : CigGlossaryRes?.hits?.hitsList, "cig");
          this.totalCigGlossaryCount = CigGlossaryRes?.hits?.total?.value;
          this.CigTabResultCount = this.totalCigSearchCount + this.totalCigGlossaryCount;
        }
        else {
          this.cigGlossaryResult = this.mapGlossaryContent([], "cig");
        }
        this.CigSearchResult = this.selectedCigFilters.length > 0 ? cigRes.hits?.hitsList?.filter(a => this.selectedCigFilters.some(filter => a.source?.levelThree != null && a.source.levelThree?.includes(filter))) : cigRes.hits?.hitsList;
        this.totalCigSearchCount = cigRes.hits?.total?.value;
        this.CigSearchResultCount = cigRes.hits?.hitsList?.length;
        this.CigTabResultCount = this.totalCigSearchCount + this.totalCigGlossaryCount;
        this.CigResultCount = this.CigSearchResultCount + this.CigGlossaryResultCount;
        this.CigGlossaryResultCount = CigGlossaryRes?.hits?.hitsList?.length;
        this.totalCigGlossaryCount = CigGlossaryRes?.hits?.total?.value;
        this.CigTabResultCount = this.totalCigSearchCount + this.totalCigGlossaryCount;
        const chapterMap: { [key: string]: any } = {};

        //Add all elements from chapterResult to the map
        (cigRes?.aggregations?.chapters?.buckets || []).forEach(item => {
          chapterMap[item.key] = { ...item };
        });
        if ((this.selectedCigFilters.includes("Glossary")) || (this.selectedCigFilters.length == 0)) {
          (CigGlossaryRes?.aggregations?.sourceTypes?.buckets || []).forEach(item => {
            if (chapterMap[item.key]) {
              chapterMap[item.key].docCount += item.docCount;
            } else {
              chapterMap[item.key] = { ...item };
            }
          });
        }

        this.chapterResult = Object.values(chapterMap);
        this.getCigFilter();
        //this.setCigGlossaryFilterCount();
        var isChapterZExist = this.chapterResult.find(x => x.key.includes("Chapter Z"));
        if (isChapterZExist) {
          let index = this.chapterResult.indexOf(this.chapterResult.find(x => x.key == "Chapter Z"), 0);
          if (index > -1) {
            this.chapterResult.splice(index, 1);
          }

        }
        this.chapterResult = this.chapterResult.sort((a, b) => {
          return this.sortChapterType(b, a);
        });
        if (isChapterZExist) {
          this.chapterResult.push(isChapterZExist);
        }
        const cigGlossaryBuckets = CigGlossaryResAggregation?.aggregations?.contentTypes?.buckets || [];
        cigGlossaryBuckets.forEach(bucket => {
          if (bucket.key === 'gasb_glossaries') {
            bucket.key = 'Glossary';
          }
        });
        this.cigContentTypeResult = [
          ...(cigResAggregation?.aggregations?.contentTypes?.buckets || []),
          ...(cigGlossaryBuckets || [])
        ];
        const desiredOrder = ['Questions and Answers', 'Glossary', 'Nonauthoritative Illustrations'];
        this.cigContentTypeResult = this.cigContentTypeResult.sort((a, b) => {
          const aIndex = desiredOrder.indexOf(a.key);
          const bIndex = desiredOrder.indexOf(b.key);
          if (aIndex !== -1 && bIndex !== -1) {
            return aIndex - bIndex;
          } else if (aIndex !== -1) {
            return -1;
          } else if (bIndex !== -1) {
            return 1;
          } else {
            return a.key.localeCompare(b.key);
          }
        });
        this.getCigFilter();
        this.setTabCount("Cig");

        this.cigSectionFilter = this.FILTER_ARRAY.filter(item => this.CigSearchResult.some(csr => csr?.source?.levelThree?.includes(item.key)) || CigGlossaryRes?.hits?.hitsList?.some(cgr => cgr?.source?.levelOne?.includes(item.key) || cgr?.source?.levelOne?.includes("gasb_glossaries")));
        this.cigFilterExists = (this.selectedChapter.length > 0 || this.cigGlossaryChecked) ? true : false;
        this.commonDataService.showLoader.next(false);
      });
  }

  onFilterSelectionChanged(st: string) {
    this.commonDataService.showLoader.next(true);
    this.selectedType = "";
    this.cigPageCount = 0;
    this.cigFilterExists = (this.selectedChapter.length > 0 || this.cigGlossaryChecked) ? true : false;
    this.elasticSearchCondition.Chapter = this.selectedChapter;
    if (!this.selectedCigFilters.includes(st)) {
      this.selectedCigFilters.push(st);
    }
    // Before assigning to elasticSearchCondition.ContentType, replace "Glossary" with "gasb_glossaries" in selectedCigFilters
    const updatedCigFilters = this.selectedCigFilters.map(f => f === "Glossary" ? "gasb_glossaries" : f);
    this.elasticSearchCondition.CIGContentType = updatedCigFilters;
    let elasticSearchConditionForAggregation = {
      Searchterm: this.elasticSearchCondition.Searchterm,
      // SourceType: "",
      Chapter: this.selectedChapter,
      DocumentType: [],
      ContentType: [],
      Section: [],
      PageNumber: this.elasticSearchCondition.PageNumber,
      PronouncementType: [],
      AuthoritativeType: [],
      CIGContentType: []
    };
    forkJoin(this.graphQlService.getCigElasticSearch(this.elasticSearchCondition, this.cigPageCount), this.graphQlService.getCigElasticSearch(elasticSearchConditionForAggregation, this.cigPageCount),
      this.graphQlService.GetMasterGlossarySearchFilter(this.elasticSearchCondition.Searchterm, 0, "CIG", this.elasticSearchCondition.Chapter, this.elasticSearchCondition.CIGContentType),
      this.graphQlService.GetMasterGlossarySearchFilter(this.elasticSearchCondition.Searchterm, 0, "CIG", this.elasticSearchCondition.Chapter, [])).
      subscribe(([cigRes, cigResAggregation, CigGlossaryRes, CigGlossaryResAggregation]) => {
        if (this.selectedCigFilters.includes("Glossary") || this.selectedCigFilters.length == 0) {
          this.CigSearchResult = cigRes.hits?.hitsList?.filter(a => a.source.levelThree?.includes("gasb_glossaries"));
          this.totalCigSearchCount = cigRes.hits?.total?.value;
          this.CigSearchResultCount = cigRes.hits?.hitsList?.length;
          this.CigTabResultCount = this.totalCigSearchCount + this.totalCigGlossaryCount;
          this.CigResultCount = this.CigSearchResultCount + this.CigGlossaryResultCount;
          this.CigGlossaryResultCount = CigGlossaryRes?.hits?.hitsList?.length;
          this.cigGlossaryResult = this.mapGlossaryContent(this.selectedCigFilters.length > 0 ? CigGlossaryRes?.hits?.hitsList?.filter(a => a.source?.levelOne != null && a.source.levelOne?.includes("gasb_glossaries")) : CigGlossaryRes?.hits?.hitsList, "cig");
          this.totalCigGlossaryCount = CigGlossaryRes?.hits?.total?.value;
          this.CigTabResultCount = this.totalCigSearchCount + this.totalCigGlossaryCount;
        }
        else {
          this.cigGlossaryResult = this.mapGlossaryContent([], "cig");
        }
        this.CigSearchResult = this.selectedCigFilters.length > 0 ? cigRes.hits?.hitsList?.filter(a => this.selectedCigFilters.some(filter => a.source?.levelThree != null && a.source.levelThree?.includes(filter))) : cigRes.hits?.hitsList;
        this.totalCigSearchCount = cigRes.hits?.total?.value;
        this.CigSearchResultCount = cigRes.hits?.hitsList?.length;
        this.CigTabResultCount = this.totalCigSearchCount + this.totalCigGlossaryCount;
        this.CigResultCount = this.CigSearchResultCount + this.CigGlossaryResultCount;
        this.CigGlossaryResultCount = CigGlossaryRes?.hits?.hitsList?.length;
        this.totalCigGlossaryCount = CigGlossaryRes?.hits?.total?.value;
        this.CigTabResultCount = this.totalCigSearchCount + this.totalCigGlossaryCount;
        const chapterMap: { [key: string]: any } = {};

         //Add all elements from chapterResult to the map
        (cigRes?.aggregations?.chapters?.buckets || []).forEach(item => {
          chapterMap[item.key] = { ...item };
        });
        if ((this.selectedCigFilters.includes("Glossary")) || (this.selectedCigFilters.length == 0)) {
          (CigGlossaryRes?.aggregations?.sourceTypes?.buckets || []).forEach(item => {
            if (chapterMap[item.key]) {
              chapterMap[item.key].docCount += item.docCount;
            } else {
              chapterMap[item.key] = { ...item };
            }
          });
        }

        this.chapterResult = Object.values(chapterMap);
        this.getCigFilter();
        //this.setCigGlossaryFilterCount();
        var isChapterZExist = this.chapterResult.find(x => x.key.includes("Chapter Z"));
        if (isChapterZExist) {
          let index = this.chapterResult.indexOf(this.chapterResult.find(x => x.key == "Chapter Z"), 0);
          if (index > -1) {
            this.chapterResult.splice(index, 1);
          }

        }
        this.chapterResult = this.chapterResult.sort((a, b) => {
          return this.sortChapterType(b, a);
        });
        if (isChapterZExist) {
          this.chapterResult.push(isChapterZExist);
        }
        const cigGlossaryBuckets = CigGlossaryResAggregation?.aggregations?.contentTypes?.buckets || [];
        cigGlossaryBuckets.forEach(bucket => {
          if (bucket.key === 'gasb_glossaries') {
            bucket.key = 'Glossary';
          }
        });
        this.cigContentTypeResult = [
          ...(cigResAggregation?.aggregations?.contentTypes?.buckets || []),
          ...(cigGlossaryBuckets || [])
        ];
        const desiredOrder = ['Questions and Answers', 'Glossary', 'Nonauthoritative Illustrations'];
        this.cigContentTypeResult = this.cigContentTypeResult.sort((a, b) => {
          const aIndex = desiredOrder.indexOf(a.key);
          const bIndex = desiredOrder.indexOf(b.key);
          if (aIndex !== -1 && bIndex !== -1) {
            return aIndex - bIndex;
          } else if (aIndex !== -1) {
            return -1;
          } else if (bIndex !== -1) {
            return 1;
          } else {
            return a.key.localeCompare(b.key);
          }
        });
        this.getCigFilter();
        this.setTabCount("Cig");

        this.cigSectionFilter = this.FILTER_ARRAY.filter(item => this.CigSearchResult.some(csr => csr?.source?.levelThree?.includes(item.key)) || CigGlossaryRes?.hits?.hitsList?.some(cgr => cgr?.source?.levelOne?.includes(item.key) || cgr?.source?.levelOne?.includes("gasb_glossaries")));
        this.cigFilterExists = (this.selectedChapter.length > 0 || this.cigGlossaryChecked) ? true : false;
        this.commonDataService.showLoader.next(false);
      });
  }


  RemovePronouncement(PronouncementNumber) {
    var pronouncementNumberExists = this.SelectedPronouncement.includes(PronouncementNumber);
    if (pronouncementNumberExists) {
      this.SelectedPronouncement.forEach((value, index) => {
        if (value == PronouncementNumber) {
          this.SelectedPronouncement.splice(index, 1);
        }
      });
    }
    this.elasticSearchCondition.PronouncementType = this.SelectedPronouncement;

    let PronouncementNumberIndex = this.GlossaryPronouncementFilter.findIndex(y => y == PronouncementNumber);
    if (PronouncementNumberIndex > -1) {
      this.GlossaryPronouncementFilter.splice(PronouncementNumberIndex, 1);
    }
    if (this.elasticSearchCondition.DocumentType.length > 0 && this.elasticSearchCondition.PronouncementType.length == 0) {
      this.elasticSearchCondition.DocumentType.forEach(x => {
        var pronouncementExists = this.GlossaryPronouncementFilter.filter(y => y.split(" ")[0] == x.split(" ")[0]);
        if (pronouncementExists.length == 0) {
          this.GlossaryPronouncementFilter.push(x);
        }
      })
    }
    forkJoin(this.graphQlService.getOpElasticSearch(this.elasticSearchCondition, 0), this.graphQlService.GetMasterGlossarySearchFilter(this.elasticSearchCondition.Searchterm, 0, "OP", this.GlossaryPronouncementFilter, [])).
      subscribe(([opRes, OpGlossaryRes]) => {
        this.OpSearchResult = opRes.hits?.hitsList;
        this.totalOpSearchCount = opRes.hits?.total?.value;
        this.OpSearchResultCount = opRes.hits?.hitsList?.length;

        this.OpGlossaryResultCount = OpGlossaryRes?.hits?.hitsList?.length;
        this.opGlossaryResult = this.mapGlossaryContent(OpGlossaryRes?.hits?.hitsList, "op");
        this.totalOpGlossaryCount = OpGlossaryRes?.hits?.total?.value;
        this.OpTabResultCount = this.totalOpSearchCount + this.totalOpGlossaryCount;
        // if(this.elasticSearchCondition.PronouncementType.length>0){
        //   // this.pronouncementNumbersResult=this.tempPronouncementNumbersResult;
        //   this.pronouncementNumbersResult=opRes?.aggregations?.pronouncementNumbers?.buckets;
        // }
        this.getOpFilter(opRes.aggregations); this.setTabCount("Op");
      })
  }

  getCodFilter(aggregateData?: any) {
    // if(this.selectedContentType.length==0 && this.SelectedSection.length==0)
    // {
    //   this.codGlossaryResult=this.tempcodGlossaryResult;
    //   this.CodTabResultCount=this.totalCodSearchCount+this.totalCodGlossaryCount;
    //   this.CodResultCount=this.CodSearchResultCount+this.CodGlossaryResultCount;
    // }
    // else if(this.selectedContentType.length>0 && this.SelectedSection.length>0){
    //   // this.codGlossaryResult=[];
    //   this.CodTabResultCount=this.totalCodSearchCount+this.totalCodGlossaryCount;
    //   this.CodResultCount=this.CodSearchResultCount+this.CodGlossaryResultCount;
    // }
    // else if (this.selectedContentType.length == 0 && this.SelectedSection.length > 0) {
    //   this.codGlossaryResult=this.tempcodGlossaryResult;
    //   this.CodTabResultCount=this.totalCodSearchCount+this.totalCodGlossaryCount;
    //   this.CodResultCount=this.CodSearchResultCount+this.CodGlossaryResultCount;
    // }
    // else if (this.selectedContentType.length > 0 && this.SelectedSection.length == 0) {
    //   this.codGlossaryResult=[];
    //   this.CodTabResultCount=this.totalCodSearchCount;
    //   this.CodResultCount=this.CodSearchResultCount;
    // }
    if (this.SelectedSection.length > 0 || (this.SelectedSection.length == 0 && this.selectedContentType.length == 0)) {
      // this.codGlossaryResult=this.tempcodGlossaryResult;
      this.CodTabResultCount = this.totalCodSearchCount + this.totalCodGlossaryCount;
      this.CodResultCount = this.CodSearchResultCount + this.CodGlossaryResultCount;
      //this.setCodGlossaryFilterCount();
    }
    else if (this.SelectedSection.length == 0 && this.selectedContentType.includes("Definitions")) {
      // this.codGlossaryResult=this.tempcodGlossaryResult;
      this.codGlossaryChecked = true;
      this.CodTabResultCount = this.totalCodSearchCount + this.totalCodGlossaryCount;
      this.CodResultCount = this.CodSearchResultCount + this.CodGlossaryResultCount;
      this.setCodGlossaryFilterCount();
    }
    else {
      this.codGlossaryResult = [];
      this.CodTabResultCount = this.totalCodSearchCount;
      this.CodResultCount = this.CodSearchResultCount;
    }
    if (aggregateData && this.selectedContentType.length == 0 && this.SelectedSection.length == 0) {
      this.sectionsResult = aggregateData.section.buckets;
      this.contentTypeResult = aggregateData.contentTypes.buckets;
      this.contentTypeResult = this.contentTypeResult.sort((a, b) => {
        return this.sortContentType(b, a);
      });
    }
    this.sectionsResult.sort((first, second) => this.sortAlphaNum(first.key, second.key) ? -1 : 1);
    this.selectedContentType.forEach(x => {
      let index = this.contentTypeResult.findIndex((obj => obj.key == x));
      if (index > -1) {
        this.contentTypeResult[index].checked = true;
      }
    })

  }

  getOpFilter(aggregateData?: any) {
    // if(this.selectedDocumentType.length==0 && this.SelectedPronouncement.length==0){
    //   // this.OpSearchResult=[];
    //   // this.opGlossaryResult=this.tempopGlossaryResult;
    //   // this.OpTabResultCount=this.totalOpGlossaryCount;
    //   // this.OpResultCount=this.OpGlossaryResultCount;

    //   this.OpTabResultCount=this.totalOpSearchCount+this.totalOpGlossaryCount;
    //   this.OpResultCount=this.OpSearchResultCount+this.OpGlossaryResultCount;
    // }
    // else if(this.selectedDocumentType.length=0 && this.selectedDocumentType.length==0)
    // {
    //   this.opGlossaryResult=this.tempopGlossaryResult;
    //   this.OpTabResultCount=this.totalOpSearchCount+this.totalOpGlossaryCount;
    //   this.OpResultCount=this.OpSearchResultCount+this.OpGlossaryResultCount;
    // }
    // else if(!this.opGlossaryChecked && (this.selectedDocumentType.length>0)){
    //   this.opGlossaryResult=[];
    //   this.OpTabResultCount=this.totalOpSearchCount;
    //   this.OpResultCount=this.OpSearchResultCount;
    // }
    // else if(this.opGlossaryChecked && (this.selectedDocumentType.length>0)){
    //   this.OpTabResultCount=this.totalOpSearchCount+this.totalOpGlossaryCount;
    //   this.OpResultCount=this.OpSearchResultCount+this.OpGlossaryResultCount;
    // }
    this.OpTabResultCount = this.totalOpSearchCount + this.totalOpGlossaryCount;
    this.OpResultCount = this.OpSearchResultCount + this.OpGlossaryResultCount;
    if (aggregateData && this.selectedDocumentType.length == 0 && this.SelectedPronouncement.length == 0) {
      this.pronouncementNumbersResult = aggregateData.pronouncementNumbers.buckets;
      if (this.opGlossaryPrononucementResult && this.opGlossaryPrononucementResult.length > 0) {
        this.opGlossaryPrononucementResult.forEach(pronouncement => {
          let pronouncementNumberKeyExists = this.pronouncementNumbersResult?.find(x => x.key == pronouncement.key);

          if (pronouncementNumberKeyExists) {
            pronouncementNumberKeyExists.docCount += pronouncement.docCount;
          }
          else {
            let obj = {
              key: pronouncement.key,
              docCount: pronouncement.docCount
            }
            this.pronouncementNumbersResult.push(obj);
          }
        })
      }
      // this.setOpGlossaryFilterCount();
      // this.pronouncementNumberList=this.pronouncementNumbersResult;
    }
    else if (aggregateData && this.selectedDocumentType.length > 0 && this.SelectedPronouncement.length == 0) {
      this.pronouncementNumbersResult = aggregateData.pronouncementNumbers.buckets;
      if (this.OpGlossaryResultCount > 0 && this.opGlossaryPrononucementResult && this.opGlossaryPrononucementResult.length > 0) {
        this.opGlossaryPrononucementResult.forEach(pronouncement => {
          let pronouncementNumberKeyExists = this.pronouncementNumbersResult?.find(x => x.key == pronouncement.key);

          if (pronouncementNumberKeyExists) {
            pronouncementNumberKeyExists.docCount += pronouncement.docCount;
          }
          else {
            if (this.selectedDocumentType.includes(pronouncement.key.split(" ")[0])) {

              let obj = {
                key: pronouncement.key,
                docCount: pronouncement.docCount
              }
              this.pronouncementNumbersResult.push(obj);
            }
          }
        })
      }
    }
    // else if(aggregateData && this.selectedDocumentType.length>0 && this.SelectedPronouncement.length==0){
    //   this.pronouncementNumbersResult = aggregateData.pronouncementNumbers.buckets;
    // }
    // else if(aggregateData && this.selectedDocumentType.length==0 && this.SelectedPronouncement.length>0 ){
    //   this.pronouncementNumbersResult = this.tempPronouncementNumbersResult;
    // }
    // else if(aggregateData && this.selectedDocumentType.length>0 && this.SelectedPronouncement.length>0){

    // }

  }

  getCigFilter() {

    this.CigTabResultCount = this.totalCigSearchCount + this.totalCigGlossaryCount;
    this.CigResultCount = this.CigSearchResultCount + this.CigGlossaryResultCount;
  }

  checkedOtherContentType(event) {
    if (event.checked) {
      this.selectedOtherContentType.push(event.source.value[0]);
    }
    else {
      this.selectedOtherContentType.forEach((value, index) => {
        if (value == event.source.value[0]) {
          this.selectedOtherContentType.splice(index, 1);
        }
      });
    }
    if (this.selectedOtherContentType.length == 0) {
      this.annotationResult = this.tempannotationResult;
      this.bookmarkResult = this.tempBookmarkResult;
    }
    if (this.selectedOtherContentType.includes("My annotations") && this.selectedOtherContentType.length > 0) {
      this.annotationResult = this.tempannotationResult;
      this.AnnotationChecked = true;
    }
    if (this.selectedOtherContentType.length > 0 && (!this.selectedOtherContentType.includes("My annotations"))) {
      this.annotationResult = [];
      this.AnnotationChecked = false;
    }
    if (this.selectedOtherContentType.includes("My bookmarks") && this.selectedOtherContentType.length > 0) {
      this.bookmarkResult = this.tempBookmarkResult;
      this.BookmarkChecked = true;
    }
    if (this.selectedOtherContentType.length > 0 && (!this.selectedOtherContentType.includes("My bookmarks"))) {
      this.bookmarkResult = [];
      this.BookmarkChecked = false;
    }
    this.setTabCount("Other");
  }

  setFocus() {
    document.getElementById("searchPage").scroll(0, 0);
  }

  enableBackToTop: boolean = false;

  EnableBackToTop() {

    // var div = document.getElementById("scrollList");
    // var div1 = document.getElementById("searchPage");
    // var div2 = document.getElementsByClassName("left-scrollbar")[0];
    var div = document.getElementById("searchPage");
    if (div != null) {
      var hasVerticalScrollbar = div.scrollHeight > div.clientHeight;

      if (hasVerticalScrollbar) {
        this.enableBackToTop = true;
      }
      else {
        this.enableBackToTop = false;
      }
    }
  }
  openLinkById(source) {
    event.preventDefault();
    var url = source.url.split("/");
    // this.route.navigateByUrl('1852827/2147481796');
    if (source.paraId == null || source.paraId == "") {
      window.open(url[1] + "/" + url[2]);
    }
    else {
      window.open(url[1] + "/" + url[2] + "/" + source.paraId);
    }
  }


  onRightClick(event: any, source) {
    var url = source.url.split("/");
    event.srcElement.parentNode.setAttribute("href", url[1] + "/" + url[2] + "/" + source.paraId);
  }

  mouseOverFunctions(event: any, source) {
    //  var url=source.url.split("/");
    //  event.srcElement.setAttribute("href",url[1]+"/"+url[2]+"/"+source.paraId);
  }

  OpenGlossaryLink(event, glossaryTitle: string) {
    const path: any = event.composedPath() as Array<any>;
    event.preventDefault();
    const xref = path.find(p => p.tagName && p.tagName.toLowerCase() === 'a' && p.className == "xref");
    const term = event.target.className.includes("term");
    if (xref) {
      // this.commonDataService.glossaryTermFromContentPageBackButton.next(glossaryTitle);
      let href = xref.getAttribute("href");
      if (href.includes("http")) {
        window.open(href);
      }
      else {
        let urlParts = href.split("/");
        let urlLastPart = href.includes('#') ? href.split('#')[1] : urlParts[urlParts.length - 1];
        let url = "/" + urlParts[1] + "/" + urlParts[2] + "/" + urlLastPart;
        window.open(url);
      }
    }
    else if (term) {
      let id = event.target.id;

      event.preventDefault();
      id = id == "" && term === "true" ? event.target.parentNode.id : id;

      this.commonDataService.rightOverlayOption.next("inline-glossary");
      this.commonDataService.rightPanelWidth.next("rightOverLay_small");
      this.commonDataService.glossaryTermId.next(id);
      this.commonDataService.showRightPanel.next(true);
    }
    else if (path.find(p => p.tagName && p.tagName.toLowerCase() === 'a')) {
      let href = path.find(p => p.tagName && p.tagName.toLowerCase() === 'a').getAttribute("href");
      let urlParts = href.split("/");
      let urlLastPart = href.includes('#') ? href.split('#')[1] : urlParts[urlParts.length - 1];
      let url = "/" + urlParts[1] + "/" + urlParts[2] + "/" + urlLastPart;
      window.open(url);
    }
  }


  onGlossaryRightClick(event: any) {
    if (event.srcElement.tagName.toLowerCase() == "a") {
      let href = event.target.getAttribute('href').split("/");
      if (href.length == 0) {
        let urlParts = href.split("/");
        let urlLastPart = href.includes('#') ? href.split('#')[1] : urlParts[urlParts.length - 1];
        event.srcElement.setAttribute("href", "/" + urlParts[1] + "/" + urlParts[2] + "/" + urlLastPart);
      }

    }
  }

  glossaryMouseOverFunctions(event: any) {
    if (event.srcElement.tagName.toLowerCase() == "a") {
      let href = event.target.getAttribute('href').split("/");
      if (href.length == 0) {
        let urlParts = href.split("/");
        let urlLastPart = href.includes('#') ? href.split('#')[1] : urlParts[urlParts.length - 1];
        event.srcElement.setAttribute("href", "/" + urlParts[1] + "/" + urlParts[2] + "/" + urlLastPart);
      }
    }
  }

  handleInputChange() {

    let inputElement = document.getElementById("searchInput") as HTMLInputElement;
    if (inputElement.value.trim() !== '') {
      this.selectedContentType = []
      this.elasticSearchCondition.ContentType = []
      this.elasticSearchCondition.Section = []
      this.contentTypeResult.forEach(c => {
        c.checked = false;
      })

      this.selectedDocumentType = []
      this.elasticSearchCondition.DocumentType = []
      this.documentTypeResult.forEach(c => {
        c.checked = false;
      })

      this.selectedChapter = []
      this.elasticSearchCondition.Chapter = []
      this.chapterResult.forEach(c => {
        c.checked = false;
      })
      this.elasticSearchCondition.CIGContentType = [];
      this.AnnotationChecked = false;
      this.BookmarkChecked = false;
      this.isButtonActive = true;
      this.isFilterLocked = true;
      this.isDropdownLocked = true;
      this.SelectedSection = [];
      this.SelectedPronouncement = [];
      this.selectedCigFilters = [];
    } else {
      this.isButtonActive = false;
    }

  }
  isButtonActive: boolean = false;
  changeBool() {
    //this.isButtonActive = true;
  }
  whenCross() {
    let inputElement = document.getElementById("searchInput") as HTMLInputElement;
    inputElement.value = "";
    //clear filters
    this.selectedContentType = []
    this.elasticSearchCondition.ContentType = []
    this.elasticSearchCondition.Section = []
    this.contentTypeResult.forEach(c => {
      c.checked = false;
    })

    this.selectedDocumentType = []
    this.elasticSearchCondition.DocumentType = []
    this.documentTypeResult.forEach(c => {
      c.checked = false;
    })

    this.selectedChapter = []
    this.elasticSearchCondition.Chapter = []
    this.chapterResult.forEach(c => {
      c.checked = false;
    })
    this.elasticSearchCondition.CIGContentType = [];
    this.AnnotationChecked = false;
    this.BookmarkChecked = false;
    this.isFilterLocked = true;
    this.isDropdownLocked = true;
    this.SelectedSection = [];
    this.SelectedPronouncement = [];
    this.selectedCigFilters = [];
    this.handleInputChange();
  }
  sendSearch() {
    if (this.isButtonActive == true) {
      this.isElasticSearchTermAvailable = true;
      this.isButtonActive = false;
      let inputElement = document.getElementById("searchInput") as HTMLInputElement;
      let term = inputElement.value;
      localStorage.setItem("ElasticSearchTerm", term);
      if (this.role != null && this.role == "Professional") {
        var searchTerm = { "Id": "-1", "SearchKeyword": term, "Application": "", "CreateDate": "", "UpdateDate": "", "UpdateUserId": "", "IsActive": true }
        this.httpCall.addSearchTerm(searchTerm).subscribe(data => console.log(data));
      }
      /*this.getSearchInputValues();*/
      if (term) {
        this.route.navigate([], {
          queryParams: { query: term },
          queryParamsHandling: 'merge'
        });
      }
    }
  }
}
